//
// Spritesheet containing all icons from src/assets/icons.
// New icons should be added manually to the spritesheet. Icons folder is for reference.
//

import React, { memo } from "react";
import { motion } from "framer-motion";

// =============================================================================
// Root
// =============================================================================
const Icons = () => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		style={{
			display: "none",
			height: "0",
			width: "0",
		}}
	>
		{/* Arrow */}
		<symbol id="arrow" viewBox="0 0 26 26" fill="#111">
			<rect width="26" height="26" transform="translate(26 26) rotate(180)" fill="white" />
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M17.2736 12.2413L5.29102 12.2413L5.29102 13.758L17.3815 13.758L12.6094 18.5301L13.6818 19.6025L19.6945 13.5898L20.2308 13.0536L19.6945 12.5174L13.6823 6.50509L12.6098 7.57754L17.2736 12.2413Z"
				fill="#111111"
			/>
		</symbol>

		{/* Arrow-Left */}
		<symbol id="arrow-left" viewBox="0 0 26 26" fill="#111">
			<rect width="26" height="26" fill="#111111" />
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M8.72639 13.7586L20.709 13.7586L20.709 12.2419L8.61851 12.2419L13.3906 7.46981L12.3182 6.39737L6.30545 12.4101L5.76923 12.9463L6.30545 13.4825L12.3177 19.4948L13.3902 18.4224L8.72639 13.7586Z"
				fill="white"
			/>
		</symbol>

		{/* Arrow-MotionDL */}
		<symbol id="arrow-motion-dl" viewBox="0 0 26 26" fill="#111">
			<rect width="26" height="26" transform="translate(26 26) rotate(180)" fill="white" />
			<motion.path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M17.2736 12.2413L5.29102 12.2413L5.29102 13.758L17.3815 13.758L12.6094 18.5301L13.6818 19.6025L19.6945 13.5898L20.2308 13.0536L19.6945 12.5174L13.6823 6.50509L12.6098 7.57754L17.2736 12.2413Z"
				fill="#111111"
				// variants={variants}
				initial={{ rotate: 135, originX: "50%", originY: "50%", translateX: "0%", translateY: "0%" }}
				animate={{
					translateX: ["0%", "0%", "0%", "0%", "-100%", "-100%", "100%", "100%", "0%", "0%", "0%", "0%"],
					translateY: ["0%", "0%", "0%", "0%", "100%", "100%", "-100%", "-100%", "0%", "0%", "0%", "0%"],
					opacity: [1, 1, 1, 1, 1, 0, 0, 1, 1, 1, 1, 1],
				}}
				transition={{ delay: 8, duration: 1.5, repeat: Infinity }}
			/>
		</symbol>

		{/* Arrow-MotionUR */}
		<symbol id="arrow-motion-ur" viewBox="0 0 26 26" fill="#111">
			<rect width="26" height="26" transform="translate(26 26) rotate(180)" fill="white" />
			<motion.path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M17.2736 12.2413L5.29102 12.2413L5.29102 13.758L17.3815 13.758L12.6094 18.5301L13.6818 19.6025L19.6945 13.5898L20.2308 13.0536L19.6945 12.5174L13.6823 6.50509L12.6098 7.57754L17.2736 12.2413Z"
				fill="#111111"
				// variants={variants}
				initial={{ rotate: 315, originX: "50%", originY: "50%", translateX: "0%", translateY: "0%" }}
				animate={{
					translateX: ["0%", "0%", "0%", "0%", "100%", "100%", "-100%", "-100%", "0%", "0%", "0%", "0%"],
					translateY: ["0%", "0%", "0%", "0%", "-100%", "-100%", "100%", "100%", "0%", "0%", "0%", "0%"],
					opacity: [1, 1, 1, 1, 1, 0, 0, 1, 1, 1, 1, 1],
				}}
				transition={{ delay: 14, duration: 1.5, repeat: Infinity }}
			/>
		</symbol>

		{/* Arrow-White */}
		<symbol id="arrow-white" viewBox="0 0 26 26" fill="none">
			<rect width="26" height="26" transform="translate(26 26) rotate(180)" fill="#111111" />
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M17.2736 12.2413L5.29102 12.2413L5.29102 13.758L17.3815 13.758L12.6094 18.5301L13.6818 19.6025L19.6945 13.5898L20.2308 13.0536L19.6945 12.5174L13.6823 6.50509L12.6098 7.57754L17.2736 12.2413Z"
				fill="white"
			/>
		</symbol>

		{/* Black */}
		<symbol id="black" viewBox="0 0 26 26" fill="none">
			<rect width="26" height="26" fill="#111111" />
		</symbol>

		{/* Baseball-Black */}
		<symbol id="baseball-black" viewBox="0 0 26 26" fill="none">
			<rect width="26" height="26" fill="#111111" />
			<path d="M11.5445 13.1247L9.39453 12.5447" stroke="white" strokeWidth="1.5" strokeMiterlimit="10" />
			<path d="M7.04492 13.1747L9.39492 12.5447" stroke="white" strokeWidth="1.5" strokeMiterlimit="10" />
			<path d="M19.375 16.1047L17.165 16.3647" stroke="white" strokeWidth="1.5" strokeMiterlimit="10" />
			<path d="M15.2148 17.8147L17.1748 16.3647" stroke="white" strokeWidth="1.5" strokeMiterlimit="10" />
			<path d="M19.3552 10.0446L17.5752 8.7146" stroke="white" strokeWidth="1.5" strokeMiterlimit="10" />
			<path d="M15.165 8.42456L17.585 8.71456" stroke="white" strokeWidth="1.5" strokeMiterlimit="10" />
			<path d="M14.4453 13.1247L16.5953 12.5447" stroke="white" strokeWidth="1.5" strokeMiterlimit="10" />
			<path d="M18.945 13.1747L16.585 12.5447" stroke="white" strokeWidth="1.5" strokeMiterlimit="10" />
			<path d="M6.61523 16.1047L8.81523 16.3647" stroke="white" strokeWidth="1.5" strokeMiterlimit="10" />
			<path d="M10.7654 17.8147L8.81543 16.3647" stroke="white" strokeWidth="1.5" strokeMiterlimit="10" />
			<path d="M6.64453 10.0446L8.42453 8.7146" stroke="white" strokeWidth="1.5" strokeMiterlimit="10" />
			<path d="M10.8341 8.42456L8.41406 8.71456" stroke="white" strokeWidth="1.5" strokeMiterlimit="10" />
			<path
				d="M6.3252 5.89453C8.2252 7.67453 9.4052 10.2045 9.4052 13.0045C9.4052 15.8045 8.2152 18.3445 6.3252 20.1145"
				stroke="white"
				strokeWidth="1.5"
				strokeMiterlimit="10"
			/>
			<path
				d="M19.665 20.1146C17.765 18.3346 16.585 15.8046 16.585 13.0046C16.585 10.4446 17.605 8.46465 18.465 7.24465C19.045 6.42465 20.265 6.41465 20.855 7.22465C22.325 9.21465 23.055 11.7946 22.635 14.5346C22.005 18.6246 18.735 21.9446 14.655 22.6046C7.97495 23.7146 2.28495 18.0246 3.38495 11.3546C4.04495 7.27465 7.35495 4.00465 11.445 3.37465C13.805 3.01465 16.045 3.49465 17.885 4.56465"
				stroke="white"
				strokeWidth="1.5"
				strokeLinejoin="round"
			/>
		</symbol>

		{/* Baseball-White */}
		<symbol id="baseball-white" viewBox="0 0 26 26" fill="none">
			<rect width="26" height="26" fill="white" />
			<path d="M11.5445 13.1247L9.39453 12.5447" stroke="black" strokeWidth="1.5" strokeMiterlimit="10" />
			<path d="M7.04492 13.1747L9.39492 12.5447" stroke="black" strokeWidth="1.5" strokeMiterlimit="10" />
			<path d="M19.375 16.1047L17.165 16.3647" stroke="black" strokeWidth="1.5" strokeMiterlimit="10" />
			<path d="M15.2148 17.8147L17.1748 16.3647" stroke="black" strokeWidth="1.5" strokeMiterlimit="10" />
			<path d="M19.3552 10.0446L17.5752 8.7146" stroke="black" strokeWidth="1.5" strokeMiterlimit="10" />
			<path d="M15.165 8.42456L17.585 8.71456" stroke="black" strokeWidth="1.5" strokeMiterlimit="10" />
			<path d="M14.4453 13.1247L16.5953 12.5447" stroke="black" strokeWidth="1.5" strokeMiterlimit="10" />
			<path d="M18.945 13.1747L16.585 12.5447" stroke="black" strokeWidth="1.5" strokeMiterlimit="10" />
			<path d="M6.61523 16.1047L8.81523 16.3647" stroke="black" strokeWidth="1.5" strokeMiterlimit="10" />
			<path d="M10.7654 17.8147L8.81543 16.3647" stroke="black" strokeWidth="1.5" strokeMiterlimit="10" />
			<path d="M6.64453 10.0446L8.42453 8.7146" stroke="black" strokeWidth="1.5" strokeMiterlimit="10" />
			<path d="M10.8341 8.42456L8.41406 8.71456" stroke="black" strokeWidth="1.5" strokeMiterlimit="10" />
			<path
				d="M6.3252 5.89453C8.2252 7.67453 9.4052 10.2045 9.4052 13.0045C9.4052 15.8045 8.2152 18.3445 6.3252 20.1145"
				stroke="black"
				strokeWidth="1.5"
				strokeMiterlimit="10"
			/>
			<path
				d="M19.665 20.1146C17.765 18.3346 16.585 15.8046 16.585 13.0046C16.585 10.4446 17.605 8.46465 18.465 7.24465C19.045 6.42465 20.265 6.41465 20.855 7.22465C22.325 9.21465 23.055 11.7946 22.635 14.5346C22.005 18.6246 18.735 21.9446 14.655 22.6046C7.97495 23.7146 2.28495 18.0246 3.38495 11.3546C4.04495 7.27465 7.35495 4.00465 11.445 3.37465C13.805 3.01465 16.045 3.49465 17.885 4.56465"
				stroke="black"
				strokeWidth="1.5"
				strokeLinejoin="round"
			/>
		</symbol>

		{/* Basketball-Black */}
		<symbol id="basketball-black" viewBox="0 0 26 26" fill="none">
			<rect width="26" height="26" fill="#111111" />
			<path d="M22.7021 13H3.20215" stroke="white" strokeWidth="1.5" strokeMiterlimit="10" />
			<path
				d="M19.9603 19.9259C18.2595 18.1514 17.209 15.7418 17.209 13.0801C17.209 10.4185 18.2595 8.00883 19.9603 6.23438"
				stroke="white"
				strokeWidth="1.5"
				strokeMiterlimit="10"
			/>
			<path
				d="M6.00391 19.9259C7.70471 18.1514 8.7552 15.7418 8.7552 13.0801C8.7552 10.4185 7.70471 8.00883 6.00391 6.23438"
				stroke="white"
				strokeWidth="1.5"
				strokeMiterlimit="10"
			/>
			<path
				d="M12.9568 3.25V21.3776C12.9568 22.1842 12.4865 23.0916 10.6757 22.6379C5.19309 21.2667 3.20215 16.4878 3.20215 13.0801C3.20215 7.65588 7.57421 3.25 12.9568 3.25ZM12.9568 3.25C18.3393 3.25 22.7114 7.65588 22.7114 13.0801C22.7114 17.5468 19.7483 21.3178 15.7013 22.5158"
				stroke="white"
				strokeWidth="1.5"
				strokeMiterlimit="10"
			/>
		</symbol>

		{/* Basketball-White */}
		<symbol id="basketball-white" viewBox="0 0 26 26" fill="none">
			<rect width="26" height="26" fill="white" />
			<path d="M22.7021 13H3.20215" stroke="#111111" strokeWidth="1.5" strokeMiterlimit="10" />
			<path
				d="M19.9603 19.9259C18.2595 18.1514 17.209 15.7418 17.209 13.0801C17.209 10.4185 18.2595 8.00883 19.9603 6.23438"
				stroke="#111111"
				strokeWidth="1.5"
				strokeMiterlimit="10"
			/>
			<path
				d="M6.00391 19.9259C7.70471 18.1514 8.7552 15.7418 8.7552 13.0801C8.7552 10.4185 7.70471 8.00883 6.00391 6.23438"
				stroke="#111111"
				strokeWidth="1.5"
				strokeMiterlimit="10"
			/>
			<path
				d="M12.9568 3.25V21.3776C12.9568 22.1842 12.4865 23.0916 10.6757 22.6379C5.19309 21.2667 3.20215 16.4878 3.20215 13.0801C3.20215 7.65588 7.57421 3.25 12.9568 3.25ZM12.9568 3.25C18.3393 3.25 22.7114 7.65588 22.7114 13.0801C22.7114 17.5468 19.7483 21.3178 15.7013 22.5158"
				stroke="#111111"
				strokeWidth="1.5"
				strokeMiterlimit="10"
			/>
		</symbol>

		{/* Bubble Caret */}
		<symbol id="bubble-caret" viewBox="0 0 18 11" fill="none">
			<path
				d="M9 0.512282L16.3592 0.67582C17.635 0.704171 18.2544 2.24797 17.3521 3.15032L10.264 10.2384C9.69788 10.8045 8.77996 10.8045 8.2138 10.2384L0.96257 2.98713C0.0492878 2.07385 0.696113 0.512282 1.98769 0.512282L9 0.512282Z"
				fill="black"
			/>
		</symbol>

		{/* Callout */}
		<symbol id="callout" viewBox="0 0 37 36" fill="none">
			<circle cx="18.75" cy="18.251" r="15.214" stroke="currentColor" strokeWidth="1.268" />
			<path
				d="M26.991 35.365h6.213a2.662 2.662 0 002.662-2.662V26.49M9.875.5H3.662A2.662 2.662 0 001 3.163v6.212"
				stroke="currentColor"
				strokeWidth=".887"
			/>
		</symbol>

		{/* Caret-up */}
		<symbol id="caret-up" viewBox="0 0 30 30" fill="none">
			<rect width="30" height="30" transform="translate(30 30) rotate(-180)" fill="white" />
			<path d="M6.29225 19.4053L14.9997 10.6965L23.7085 19.4053" stroke="#111111" strokeWidth="2" />
		</symbol>

		{/* Chevron-right */}
		<symbol id="chevron-right" viewBox="0 0 14 14" fill="none">
			<path d="M6 13l6-6-6-6" stroke="currentColor" strokeWidth="2" />
		</symbol>

		{/* Chevron-left */}
		<symbol id="chevron-left" viewBox="0 0 14 14" fill="none">
			<path
				d="M6 13l6-6-6-6"
				stroke="currentColor"
				strokeWidth="2"
				transform="rotate(0 180 0)"
				style={{
					transform: "rotate(180deg)",
					transformOrigin: "center",
				}}
			/>
		</symbol>

		{/* Close */}
		<symbol id="close" viewBox="0 0 26 26" fill="none">
			<rect width="26" height="26" fill="#111111" />
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M12.9329 11.8722L17.3052 7.49991L18.3659 8.56057L13.9936 12.9329L18.3659 17.3052L17.3052 18.3658L12.9329 13.9935L8.56066 18.3658L7.5 17.3051L11.8723 12.9329L7.5 8.56061L8.56066 7.49995L12.9329 11.8722Z"
				fill="white"
			/>
		</symbol>

		{/* Clock */}
		<symbol id="clock" viewBox="0 0 24 24" fill="none">
			<rect width="24" height="24" fill="white" />
			<path d="M12 6V12H17.25" stroke="#111111" strokeWidth="1.5" />
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M20.25 12C20.25 16.557 16.556 20.25 12 20.25C7.444 20.25 3.75 16.557 3.75 12C3.75 7.443 7.444 3.75 12 3.75C16.556 3.75 20.25 7.443 20.25 12Z"
				stroke="#111111"
				strokeWidth="1.5"
			/>
		</symbol>

		{/* Elevation */}
		<symbol id="elevation" viewBox="0 0 24 24" fill="none">
			<rect width="24" height="24" fill="white" />
			<path
				d="M2.25 8.9131L7.625 5.8091C8.321 5.4071 9.179 5.4071 9.875 5.8091L14.125 8.2641C14.821 8.6651 15.679 8.6651 16.375 8.2641L21.75 5.1601"
				stroke="#111111"
				strokeWidth="1.5"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M10.3066 18.75H4.7496C3.3696 18.75 2.2496 17.631 2.2496 16.25V12.38L7.6246 9.277C8.3216 8.875 9.1786 8.875 9.8746 9.277L14.1246 11.73C14.8216 12.133 15.6786 12.133 16.3746 11.73L20.6246 9.277C21.1246 8.988 21.7496 9.35 21.7496 9.927V16.25C21.7496 17.631 20.6306 18.75 19.2496 18.75H10.3066Z"
				stroke="#111111"
				strokeWidth="1.5"
			/>
		</symbol>

		{/* Football-Black */}
		<symbol id="football-black" viewBox="0 0 26 26" fill="none">
			<rect width="26" height="26" fill="#111111" />
			<path
				d="M4.41838 15.7326C6.3554 18.1984 9.40713 19.7829 12.8426 19.7829C17.2831 19.7829 21.0841 17.1212 22.6739 13.3469C22.7653 13.1332 22.7653 12.884 22.6739 12.6704C21.0841 8.896 17.2923 6.23438 12.8426 6.23438C8.67618 6.23438 5.07623 8.56664 3.34022 11.9671C2.98388 12.6704 3.37677 13.3736 4.17168 13.5338C14.9441 15.6346 22.747 13.0086 22.747 13.0086"
				stroke="white"
				strokeWidth="1.5"
				strokeMiterlimit="10"
			/>
			<path d="M12.8975 4.72119V8.18398" stroke="white" strokeWidth="1.5" strokeMiterlimit="10" />
			<path d="M8.83105 5.49561L9.96336 8.62903" stroke="white" strokeWidth="1.5" strokeMiterlimit="10" />
			<path d="M16.9624 5.49561L15.8301 8.62903" stroke="white" strokeWidth="1.5" strokeMiterlimit="10" />
		</symbol>

		{/* Football-White */}
		<symbol id="football-white" viewBox="0 0 26 26" fill="none">
			<rect width="26" height="26" fill="white" />
			<path
				d="M4.41838 15.7326C6.3554 18.1984 9.40713 19.7829 12.8426 19.7829C17.2831 19.7829 21.0841 17.1212 22.6739 13.3469C22.7653 13.1332 22.7653 12.884 22.6739 12.6704C21.0841 8.896 17.2923 6.23438 12.8426 6.23438C8.67618 6.23438 5.07623 8.56664 3.34022 11.9671C2.98388 12.6704 3.37677 13.3736 4.17168 13.5338C14.9441 15.6346 22.747 13.0086 22.747 13.0086"
				stroke="black"
				strokeWidth="1.5"
				strokeMiterlimit="10"
			/>
			<path d="M12.8975 4.72119V8.18398" stroke="black" strokeWidth="1.5" strokeMiterlimit="10" />
			<path d="M8.83105 5.49561L9.96336 8.62903" stroke="black" strokeWidth="1.5" strokeMiterlimit="10" />
			<path d="M16.9624 5.49561L15.8301 8.62903" stroke="black" strokeWidth="1.5" strokeMiterlimit="10" />
		</symbol>

		{/* Globe-White */}
		<symbol id="globe-white" viewBox="0 0 30 30" fill="none">
			<rect width="30" height="30" fill="white" />
			<path
				d="M15 24.75C20.3848 24.75 24.75 20.3848 24.75 15C24.75 9.61522 20.3848 5.25 15 5.25C9.61522 5.25 5.25 9.61522 5.25 15C5.25 20.3848 9.61522 24.75 15 24.75Z"
				stroke="#111111"
				strokeWidth="1.5"
				strokeMiterlimit="10"
			/>
			<path
				d="M15 24.75C17.8995 24.75 20.25 20.3848 20.25 15C20.25 9.61522 17.8995 5.25 15 5.25C12.1005 5.25 9.75 9.61522 9.75 15C9.75 20.3848 12.1005 24.75 15 24.75Z"
				stroke="#111111"
				strokeWidth="1.5"
				strokeMiterlimit="10"
			/>
			<path
				d="M15 18.75C20.3848 18.75 24.75 17.0711 24.75 15C24.75 12.9289 20.3848 11.25 15 11.25C9.61522 11.25 5.25 12.9289 5.25 15C5.25 17.0711 9.61522 18.75 15 18.75Z"
				stroke="#111111"
				strokeWidth="1.5"
				strokeMiterlimit="10"
			/>
		</symbol>

		{/* Golf-Black */}
		<symbol id="golf-black" viewBox="0 0 26 26" fill="none">
			<rect width="26" height="26" fill="#111111" />
			<path
				d="M20.2505 7.18148L13.0059 3.85815V10.5048L20.2505 7.18148Z"
				stroke="white"
				strokeWidth="1.5"
				strokeMiterlimit="10"
			/>
			<path d="M13.0059 2.51514V20.4748" stroke="white" strokeWidth="1.5" strokeMiterlimit="10" />
			<path
				d="M15.1229 18.2495C17.662 18.573 19.4854 19.4455 19.4854 20.4749C19.4854 21.7787 16.5836 22.8277 13.0054 22.8277C9.42718 22.8277 6.52539 21.7689 6.52539 20.4749C6.52539 19.1808 9.42718 18.1221 13.0054 18.1221"
				stroke="white"
				strokeWidth="1.5"
				strokeMiterlimit="10"
			/>
			<path
				d="M19.4851 15.2105C20.4326 15.2105 21.2007 14.4424 21.2007 13.4949C21.2007 12.5474 20.4326 11.7793 19.4851 11.7793C18.5376 11.7793 17.7695 12.5474 17.7695 13.4949C17.7695 14.4424 18.5376 15.2105 19.4851 15.2105Z"
				stroke="white"
				strokeWidth="1.5"
				strokeMiterlimit="10"
			/>
		</symbol>

		{/* Golf-White */}
		<symbol id="golf-white" viewBox="0 0 26 26" fill="none">
			<rect width="26" height="26" fill="white" />
			<path
				d="M20.2505 7.18148L13.0059 3.85815V10.5048L20.2505 7.18148Z"
				stroke="black"
				strokeWidth="1.5"
				strokeMiterlimit="10"
			/>
			<path d="M13.0059 2.51514V20.4748" stroke="black" strokeWidth="1.5" strokeMiterlimit="10" />
			<path
				d="M15.1229 18.2495C17.662 18.573 19.4854 19.4455 19.4854 20.4749C19.4854 21.7787 16.5836 22.8277 13.0054 22.8277C9.42718 22.8277 6.52539 21.7689 6.52539 20.4749C6.52539 19.1808 9.42718 18.1221 13.0054 18.1221"
				stroke="black"
				strokeWidth="1.5"
				strokeMiterlimit="10"
			/>
			<path
				d="M19.4851 15.2105C20.4326 15.2105 21.2007 14.4424 21.2007 13.4949C21.2007 12.5474 20.4326 11.7793 19.4851 11.7793C18.5376 11.7793 17.7695 12.5474 17.7695 13.4949C17.7695 14.4424 18.5376 15.2105 19.4851 15.2105Z"
				stroke="black"
				strokeWidth="1.5"
				strokeMiterlimit="10"
			/>
		</symbol>

		{/* Heart */}
		<symbol id="heart" viewBox="0 0 16 14" fill="none">
			<path
				d="M11.1966 1.00001C12.0793 1.00001 12.9086 1.34401 13.5326 1.96734C14.8213 3.25534 14.8213 5.35134 13.5326 6.63934L8.00062 12.172L2.46795 6.63934C1.17995 5.35134 1.17995 3.25534 2.46795 1.96801C3.09195 1.34401 3.92129 1.00001 4.80395 1.00001C5.68662 1.00001 6.51595 1.34401 7.13995 1.96734L7.64662 2.47401L8.00062 2.82801L8.35395 2.47401L8.86062 1.96734C9.48462 1.34401 10.314 1.00001 11.1966 1.00001"
				stroke="black"
				strokeWidth="1.25"
			/>
		</symbol>

		{/* Heart Filled */}
		<symbol id="heart-filled" viewBox="0 0 16 14" fill="black">
			<path
				d="M11.1966 1.00001C12.0793 1.00001 12.9086 1.34401 13.5326 1.96734C14.8213 3.25534 14.8213 5.35134 13.5326 6.63934L8.00062 12.172L2.46795 6.63934C1.17995 5.35134 1.17995 3.25534 2.46795 1.96801C3.09195 1.34401 3.92129 1.00001 4.80395 1.00001C5.68662 1.00001 6.51595 1.34401 7.13995 1.96734L7.64662 2.47401L8.00062 2.82801L8.35395 2.47401L8.86062 1.96734C9.48462 1.34401 10.314 1.00001 11.1966 1.00001"
				stroke="black"
				strokeWidth="1.25"
			/>
		</symbol>

		{/* Instagram */}
		<symbol id="instagram" viewBox="0 0 30 30" fill="none">
			<path
				d="M15.001 0c-4.073 0-4.585.018-6.185.09C7.22.165 6.13.418 5.176.789a7.345 7.345 0 00-2.658 1.73 7.363 7.363 0 00-1.73 2.656C.414 6.128.161 7.218.09 8.814.02 10.415 0 10.927 0 15s.018 4.583.09 6.183c.074 1.597.327 2.687.698 3.641a7.35 7.35 0 001.73 2.657 7.345 7.345 0 002.656 1.731c.954.371 2.045.624 3.641.697 1.6.073 2.111.091 6.184.091 4.075 0 4.584-.018 6.184-.09 1.597-.074 2.689-.327 3.643-.698a7.34 7.34 0 002.655-1.73 7.365 7.365 0 001.731-2.658c.37-.954.622-2.044.697-3.64.072-1.6.091-2.11.091-6.184s-.019-4.585-.09-6.185c-.076-1.597-.329-2.687-.698-3.64a7.362 7.362 0 00-1.73-2.658 7.33 7.33 0 00-2.657-1.73c-.956-.37-2.047-.623-3.644-.696C19.581.018 19.071 0 14.997 0H15zm-1.345 2.703H15c4.005 0 4.48.014 6.062.086 1.462.067 2.256.312 2.785.517.7.272 1.199.597 1.724 1.122.524.525.85 1.025 1.122 1.725.205.528.45 1.322.517 2.784.072 1.581.087 2.056.087 6.06 0 4.003-.015 4.478-.087 6.059-.067 1.462-.312 2.256-.517 2.784a4.638 4.638 0 01-1.122 1.723 4.639 4.639 0 01-1.724 1.122c-.528.207-1.323.45-2.785.517-1.581.072-2.057.088-6.062.088-4.005 0-4.48-.016-6.06-.088-1.463-.067-2.257-.312-2.786-.517-.7-.272-1.2-.597-1.725-1.122a4.649 4.649 0 01-1.123-1.724c-.205-.528-.45-1.322-.516-2.784-.072-1.582-.087-2.057-.087-6.062 0-4.006.015-4.478.087-6.06.067-1.462.31-2.256.516-2.785.272-.7.598-1.2 1.123-1.725a4.655 4.655 0 011.725-1.122c.529-.206 1.323-.45 2.785-.517 1.384-.063 1.92-.081 4.716-.085v.004zm9.352 2.49a1.8 1.8 0 100 3.602 1.8 1.8 0 000-3.602zm-8.007 2.104a7.703 7.703 0 10.002 15.407A7.703 7.703 0 0015 7.297zm0 2.703a5 5 0 110 10 5 5 0 010-10z"
				fill="currentColor"
			/>
		</symbol>

		{/* Jumpman-Black */}
		<symbol id="jumpman-black" viewBox="0 0 30 30" fill="none">
			<rect width="30" height="30" fill="black" />
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M16.1815 8.07992C16.1695 8.04092 16.1695 8.04092 16.1695 8.00792C16.1475 7.47792 16.5575 7.02292 17.0915 7.00092C17.6205 6.97792 18.0705 7.38892 18.0985 7.92292C18.1205 8.45692 17.7105 8.90692 17.1815 8.92992C17.1545 8.93392 17.1195 8.92992 17.0805 8.92992C17.0645 8.93392 17.0415 8.93392 17.0245 8.95192C16.9685 9.03592 17.1645 9.02492 17.0195 9.39092C17.0195 9.39092 17.0195 9.42992 17.0075 9.46892C16.9955 9.60892 16.9285 10.0309 16.9115 10.2619C16.9405 10.3019 16.9515 10.3119 16.9405 10.3919C16.9285 10.4979 16.8895 10.7569 16.8505 10.9259C16.8105 11.0659 16.7545 11.0999 16.7035 11.1279C16.6305 11.4259 16.6085 11.6729 16.4225 12.0329C16.4005 12.3089 16.3775 12.3819 16.3165 12.5169C16.2995 12.9159 16.3275 12.9769 16.0355 13.6179C15.9555 13.9169 16.0185 14.1249 16.0855 14.4389C16.1535 14.7599 16.3615 14.8999 16.3835 15.2319C16.4345 16.0029 16.4005 16.5369 16.2205 17.1389L16.3555 17.4869C16.5355 17.5709 16.9735 17.8129 16.7155 18.1619C17.0585 18.3519 17.5805 18.5559 17.9965 18.9429C18.1715 19.0899 18.3455 19.2579 18.5085 19.4429C18.8245 19.4999 18.7845 19.5219 19.0145 19.6739C19.6895 20.1119 20.7635 20.9779 21.3875 21.5799C21.4995 21.6469 21.5345 21.6919 21.6235 21.7429C21.6345 21.7659 21.6405 21.7769 21.6345 21.7819C21.6075 21.8549 21.6075 21.8549 21.5735 21.9229C21.6125 21.9629 21.6685 21.9959 21.7075 22.0299C21.7475 22.0349 21.7475 22.0239 21.8035 22.0129C21.8825 22.0859 21.9835 22.1479 22.0175 22.1479C22.1235 22.1259 22.1015 22.1429 22.2025 22.0469C22.2315 22.0129 22.2865 22.0469 22.2865 22.0469C22.3275 22.0079 22.3995 21.9289 22.5005 21.8719C22.5795 21.8269 22.7315 21.8269 22.7315 21.8269C22.7825 21.8329 22.7705 21.8779 22.7595 21.8999C22.7025 21.9229 22.5795 21.9569 22.5125 22.0079C22.3605 22.1479 22.2365 22.3609 22.2365 22.3609C22.5355 22.3279 22.7205 22.4059 22.9555 22.3839C23.0915 22.3789 23.1925 22.3899 23.3325 22.2939C23.3325 22.2939 23.4735 22.1979 23.5975 22.1529C23.7155 22.1029 23.8275 22.1369 23.9285 22.2159C23.9965 22.2999 24.0465 22.2999 23.9285 22.4119C23.8835 22.4569 23.8275 22.5079 23.7485 22.5809C23.6145 22.7049 23.4345 22.8729 23.2485 23.0139C23.0575 23.1539 22.8495 23.2719 22.7205 23.3289C22.3825 23.5589 22.4615 23.5029 22.1975 23.7229C22.1685 23.7449 22.0735 23.8009 22.0345 23.8289C21.9275 23.8909 21.8995 23.8349 21.8375 23.7109C21.8375 23.7109 21.8095 23.6659 21.7585 23.5699C21.7075 23.4639 21.6685 23.3399 21.6855 23.3399C21.6235 23.3339 21.3545 22.9969 21.3545 22.9299C21.2915 22.9179 21.0505 22.6709 21.0445 22.6199L20.8305 22.4399C20.5775 22.4849 20.5215 22.3279 19.8695 21.8329C19.7905 21.8269 19.6725 21.7819 19.5095 21.6589C19.2115 21.4059 18.5025 20.8439 18.3855 20.7759C18.2555 20.7089 18.1045 20.6419 18.0025 20.5619C17.8565 20.5399 17.7845 20.5119 17.7045 20.4949C17.6255 20.4729 17.5645 20.4379 17.3785 20.4159C17.0755 20.3709 16.7605 20.2359 16.4675 20.0789C16.3275 20.0059 16.2035 19.9719 16.0855 19.9099C15.8155 19.7859 15.5795 19.6739 15.3995 19.6289C15.3315 19.6229 15.0005 19.5109 14.8315 19.4039C14.7705 19.3699 14.7365 19.3429 14.6975 19.3309C14.6075 19.3089 14.5445 19.3369 14.5055 19.3529C14.2755 19.4609 14.0675 19.5559 13.8695 19.6629C13.6905 19.7529 13.5215 19.8489 13.3415 19.9489C13.1845 20.0339 12.9985 20.1179 12.8075 20.2029C12.8075 20.2029 12.2735 20.4559 11.9755 20.5509C11.7165 20.7479 11.1885 21.0969 10.8685 21.2659C10.7105 21.3389 10.4015 21.5179 10.2605 21.5579C10.1815 21.6189 9.88952 21.8159 9.66452 21.9789C9.48452 22.1029 9.35552 22.2099 9.35552 22.2099C9.24852 22.2939 9.25352 22.3389 9.07452 22.2549C9.01852 22.2939 8.97852 22.3219 8.94552 22.3509C8.80452 22.4459 8.79852 22.4239 8.74252 22.4179C8.64152 22.4969 8.62952 22.4569 8.54552 22.5469C8.48452 22.6319 8.54552 22.6089 8.42752 22.6539C8.39952 22.6599 8.38852 22.6929 8.37052 22.7099C8.27652 22.7829 8.27052 23.0029 8.04552 23.0139C7.91052 23.1029 7.93852 23.2169 7.84852 23.2049C7.84852 23.3069 7.66852 23.4349 7.63452 23.4349C7.34252 23.5309 7.33052 23.3169 6.98852 23.4699C6.94352 23.4859 6.87552 23.5419 6.79152 23.5539C6.63952 23.5759 6.45952 23.5479 6.34752 23.4519C6.17852 23.3109 6.02152 23.0539 6.02152 23.0539C5.97052 22.9239 6.00452 22.8459 6.18452 22.7219C6.25752 22.6769 6.26852 22.6429 6.39252 22.6379C6.45352 22.6139 6.43752 22.6479 6.54352 22.6139C6.60652 22.5979 6.60652 22.6089 6.73552 22.6089C6.76352 22.5919 6.80252 22.5869 6.85952 22.5639C6.95952 22.5299 7.05552 22.5019 7.05552 22.5019C7.05552 22.5019 7.08352 22.4789 7.17952 22.4909C7.25752 22.4569 7.34852 22.4119 7.39352 22.3949C7.38152 22.2709 7.39852 22.2709 7.45452 22.2209C7.53452 22.1589 7.54452 22.1709 7.60152 22.2099C7.62352 22.2039 7.64052 22.1979 7.62852 22.1759C7.61852 22.1029 7.56752 22.0689 7.58352 21.9289C7.56152 21.8719 7.52252 21.7999 7.53452 21.7549C7.54452 21.7099 7.56152 21.6859 7.58952 21.6759C7.61852 21.6639 7.63452 21.6819 7.64652 21.6979C7.67452 21.7319 7.69752 21.8329 7.69752 21.8329C7.70252 21.9509 7.73652 22.0919 7.84852 22.0129C7.91552 21.9509 7.93252 21.7709 8.06252 21.8099L8.15852 21.8949C8.24252 21.8219 8.24252 21.8219 8.29852 21.7879C8.29852 21.7879 8.21952 21.7149 8.28652 21.6529C8.33152 21.6139 8.39452 21.5859 8.49452 21.4779C8.77052 21.1859 8.91652 21.0579 9.20852 20.8209C9.80552 20.3599 10.4805 20.0399 10.9075 19.8819C11.0535 19.7079 11.1885 19.5959 11.4925 19.5779C11.8695 18.9719 12.5775 18.4419 12.7405 18.3579C12.8745 18.1279 12.9315 18.1499 13.1055 18.1109C13.2405 18.0039 13.2805 18.0039 13.3355 17.8969C13.3985 17.6669 13.2235 17.0369 13.7185 17.0199C13.8305 16.8739 13.7965 16.9079 13.9145 16.7719C13.8425 16.5759 13.8145 16.4129 13.7965 16.2719C13.7915 16.2559 13.6005 16.1149 13.6675 15.9399C13.5885 15.8399 13.4375 15.6139 13.3985 15.5079C13.3755 15.5079 13.3535 15.5019 13.3355 15.4959C13.3135 15.4909 13.2805 15.4909 13.2455 15.4909C13.1675 15.6869 13.0825 15.6989 12.9425 15.7439C12.6835 16.2559 12.5935 16.4749 11.8965 16.8859C11.6165 17.1839 11.5145 17.5259 11.5145 17.5199C11.4635 17.6219 11.4755 17.7629 11.5025 17.8409C11.4575 17.9479 11.4755 17.9649 11.4755 17.9649C11.4865 18.0099 11.5315 18.0709 11.5815 18.0769C11.6605 18.0999 11.7505 18.0999 11.7395 18.1949C11.7285 18.3079 11.5765 18.2849 11.5025 18.2679C11.2275 18.2179 11.3175 18.0379 11.1375 18.0939C10.9965 18.1789 10.9415 18.4419 10.7215 18.4029C10.6935 18.3809 10.7045 18.3299 10.7275 18.2849C10.7555 18.2239 10.8115 18.1669 10.7835 18.1439C10.6375 18.1839 10.3505 18.2679 10.3505 18.2679C10.2155 18.3079 10.0695 18.2289 10.2035 18.1439C10.2665 18.1219 10.3565 18.0939 10.4685 18.0259C10.4685 18.0259 10.5305 17.9539 10.4115 17.9869C10.2945 18.0259 10.1195 18.0439 9.99552 18.0319C9.99552 18.0319 9.73852 17.9929 9.70352 17.9759C9.67552 17.9539 9.64252 17.8689 9.72052 17.8749C9.82752 17.8809 10.0865 17.8519 10.2835 17.8079C10.3785 17.7729 10.5645 17.6669 10.6655 17.6219C10.6655 17.6219 10.7785 17.4649 10.8455 17.4309C10.9525 17.3179 11.0365 17.2509 11.1265 17.1329C11.2165 16.9529 11.3175 16.6719 11.6265 16.2269C11.7675 16.0249 11.9415 15.7889 12.1605 15.5809C12.1605 15.5809 12.2225 15.2429 12.5035 15.0079C12.5665 14.8669 12.6605 14.6979 12.7625 14.5459C12.8015 14.4899 12.8355 14.4389 12.8685 14.3779C12.9595 14.2479 13.0545 14.0009 13.3865 13.9669C13.3865 13.9669 13.5335 13.8659 13.5835 13.7929C13.6675 13.7199 13.6575 13.6069 13.7245 13.5339C13.6175 13.4279 13.3585 13.2249 13.3415 12.9609C13.3255 12.6679 13.4255 12.4429 13.6065 12.2689C13.8025 12.0839 14.0045 11.9939 14.2525 12.0109C14.5615 12.0659 14.6185 12.1679 14.7075 12.2689C14.7975 12.3699 14.8375 12.3089 14.8705 12.4149C15.1295 12.4879 15.1185 12.4599 15.1075 12.6509C15.1525 12.7079 15.2135 12.7589 15.2085 12.8649C15.2925 12.6899 15.3155 12.6569 15.5515 12.4659C15.6135 12.3089 15.6525 12.1509 15.7025 11.9879C15.7535 11.8419 15.8155 11.6899 15.8555 11.5779C15.8155 11.2519 15.9165 11.2009 16.0515 10.9139C16.0295 10.8749 16.0355 10.8629 16.0455 10.8019C16.1025 10.6099 16.1815 10.3689 16.2315 10.2059C16.2315 10.2059 16.2485 10.1429 16.3165 10.1429C16.3775 9.94092 16.4735 9.56392 16.4955 9.47992C16.5575 9.27192 16.5245 9.19292 16.4855 9.06992C16.4735 9.02992 16.4795 8.97992 16.4565 8.93392C16.3895 8.81092 16.3165 8.64192 16.2655 8.52392C16.2375 8.45092 16.1865 8.16992 16.1865 8.16992C16.1815 8.10792 16.1815 8.07992 16.1815 8.07992"
				fill="white"
			/>
		</symbol>

		{/* Jumpman-White */}
		<symbol id="jumpman-white" viewBox="0 0 30 30" fill="none">
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M16.1815 8.07992C16.1695 8.04092 16.1695 8.04092 16.1695 8.00792C16.1475 7.47792 16.5575 7.02292 17.0915 7.00092C17.6205 6.97792 18.0705 7.38892 18.0985 7.92292C18.1205 8.45692 17.7105 8.90692 17.1815 8.92992C17.1545 8.93392 17.1195 8.92992 17.0805 8.92992C17.0645 8.93392 17.0415 8.93392 17.0245 8.95192C16.9685 9.03592 17.1645 9.02492 17.0195 9.39092C17.0195 9.39092 17.0195 9.42992 17.0075 9.46892C16.9955 9.60892 16.9285 10.0309 16.9115 10.2619C16.9405 10.3019 16.9515 10.3119 16.9405 10.3919C16.9285 10.4979 16.8895 10.7569 16.8505 10.9259C16.8105 11.0659 16.7545 11.0999 16.7035 11.1279C16.6305 11.4259 16.6085 11.6729 16.4225 12.0329C16.4005 12.3089 16.3775 12.3819 16.3165 12.5169C16.2995 12.9159 16.3275 12.9769 16.0355 13.6179C15.9555 13.9169 16.0185 14.1249 16.0855 14.4389C16.1535 14.7599 16.3615 14.8999 16.3835 15.2319C16.4345 16.0029 16.4005 16.5369 16.2205 17.1389L16.3555 17.4869C16.5355 17.5709 16.9735 17.8129 16.7155 18.1619C17.0585 18.3519 17.5805 18.5559 17.9965 18.9429C18.1715 19.0899 18.3455 19.2579 18.5085 19.4429C18.8245 19.4999 18.7845 19.5219 19.0145 19.6739C19.6895 20.1119 20.7635 20.9779 21.3875 21.5799C21.4995 21.6469 21.5345 21.6919 21.6235 21.7429C21.6345 21.7659 21.6405 21.7769 21.6345 21.7819C21.6075 21.8549 21.6075 21.8549 21.5735 21.9229C21.6125 21.9629 21.6685 21.9959 21.7075 22.0299C21.7475 22.0349 21.7475 22.0239 21.8035 22.0129C21.8825 22.0859 21.9835 22.1479 22.0175 22.1479C22.1235 22.1259 22.1015 22.1429 22.2025 22.0469C22.2315 22.0129 22.2865 22.0469 22.2865 22.0469C22.3275 22.0079 22.3995 21.9289 22.5005 21.8719C22.5795 21.8269 22.7315 21.8269 22.7315 21.8269C22.7825 21.8329 22.7705 21.8779 22.7595 21.8999C22.7025 21.9229 22.5795 21.9569 22.5125 22.0079C22.3605 22.1479 22.2365 22.3609 22.2365 22.3609C22.5355 22.3279 22.7205 22.4059 22.9555 22.3839C23.0915 22.3789 23.1925 22.3899 23.3325 22.2939C23.3325 22.2939 23.4735 22.1979 23.5975 22.1529C23.7155 22.1029 23.8275 22.1369 23.9285 22.2159C23.9965 22.2999 24.0465 22.2999 23.9285 22.4119C23.8835 22.4569 23.8275 22.5079 23.7485 22.5809C23.6145 22.7049 23.4345 22.8729 23.2485 23.0139C23.0575 23.1539 22.8495 23.2719 22.7205 23.3289C22.3825 23.5589 22.4615 23.5029 22.1975 23.7229C22.1685 23.7449 22.0735 23.8009 22.0345 23.8289C21.9275 23.8909 21.8995 23.8349 21.8375 23.7109C21.8375 23.7109 21.8095 23.6659 21.7585 23.5699C21.7075 23.4639 21.6685 23.3399 21.6855 23.3399C21.6235 23.3339 21.3545 22.9969 21.3545 22.9299C21.2915 22.9179 21.0505 22.6709 21.0445 22.6199L20.8305 22.4399C20.5775 22.4849 20.5215 22.3279 19.8695 21.8329C19.7905 21.8269 19.6725 21.7819 19.5095 21.6589C19.2115 21.4059 18.5025 20.8439 18.3855 20.7759C18.2555 20.7089 18.1045 20.6419 18.0025 20.5619C17.8565 20.5399 17.7845 20.5119 17.7045 20.4949C17.6255 20.4729 17.5645 20.4379 17.3785 20.4159C17.0755 20.3709 16.7605 20.2359 16.4675 20.0789C16.3275 20.0059 16.2035 19.9719 16.0855 19.9099C15.8155 19.7859 15.5795 19.6739 15.3995 19.6289C15.3315 19.6229 15.0005 19.5109 14.8315 19.4039C14.7705 19.3699 14.7365 19.3429 14.6975 19.3309C14.6075 19.3089 14.5445 19.3369 14.5055 19.3529C14.2755 19.4609 14.0675 19.5559 13.8695 19.6629C13.6905 19.7529 13.5215 19.8489 13.3415 19.9489C13.1845 20.0339 12.9985 20.1179 12.8075 20.2029C12.8075 20.2029 12.2735 20.4559 11.9755 20.5509C11.7165 20.7479 11.1885 21.0969 10.8685 21.2659C10.7105 21.3389 10.4015 21.5179 10.2605 21.5579C10.1815 21.6189 9.88952 21.8159 9.66452 21.9789C9.48452 22.1029 9.35552 22.2099 9.35552 22.2099C9.24852 22.2939 9.25352 22.3389 9.07452 22.2549C9.01852 22.2939 8.97852 22.3219 8.94552 22.3509C8.80452 22.4459 8.79852 22.4239 8.74252 22.4179C8.64152 22.4969 8.62952 22.4569 8.54552 22.5469C8.48452 22.6319 8.54552 22.6089 8.42752 22.6539C8.39952 22.6599 8.38852 22.6929 8.37052 22.7099C8.27652 22.7829 8.27052 23.0029 8.04552 23.0139C7.91052 23.1029 7.93852 23.2169 7.84852 23.2049C7.84852 23.3069 7.66852 23.4349 7.63452 23.4349C7.34252 23.5309 7.33052 23.3169 6.98852 23.4699C6.94352 23.4859 6.87552 23.5419 6.79152 23.5539C6.63952 23.5759 6.45952 23.5479 6.34752 23.4519C6.17852 23.3109 6.02152 23.0539 6.02152 23.0539C5.97052 22.9239 6.00452 22.8459 6.18452 22.7219C6.25752 22.6769 6.26852 22.6429 6.39252 22.6379C6.45352 22.6139 6.43752 22.6479 6.54352 22.6139C6.60652 22.5979 6.60652 22.6089 6.73552 22.6089C6.76352 22.5919 6.80252 22.5869 6.85952 22.5639C6.95952 22.5299 7.05552 22.5019 7.05552 22.5019C7.05552 22.5019 7.08352 22.4789 7.17952 22.4909C7.25752 22.4569 7.34852 22.4119 7.39352 22.3949C7.38152 22.2709 7.39852 22.2709 7.45452 22.2209C7.53452 22.1589 7.54452 22.1709 7.60152 22.2099C7.62352 22.2039 7.64052 22.1979 7.62852 22.1759C7.61852 22.1029 7.56752 22.0689 7.58352 21.9289C7.56152 21.8719 7.52252 21.7999 7.53452 21.7549C7.54452 21.7099 7.56152 21.6859 7.58952 21.6759C7.61852 21.6639 7.63452 21.6819 7.64652 21.6979C7.67452 21.7319 7.69752 21.8329 7.69752 21.8329C7.70252 21.9509 7.73652 22.0919 7.84852 22.0129C7.91552 21.9509 7.93252 21.7709 8.06252 21.8099L8.15852 21.8949C8.24252 21.8219 8.24252 21.8219 8.29852 21.7879C8.29852 21.7879 8.21952 21.7149 8.28652 21.6529C8.33152 21.6139 8.39452 21.5859 8.49452 21.4779C8.77052 21.1859 8.91652 21.0579 9.20852 20.8209C9.80552 20.3599 10.4805 20.0399 10.9075 19.8819C11.0535 19.7079 11.1885 19.5959 11.4925 19.5779C11.8695 18.9719 12.5775 18.4419 12.7405 18.3579C12.8745 18.1279 12.9315 18.1499 13.1055 18.1109C13.2405 18.0039 13.2805 18.0039 13.3355 17.8969C13.3985 17.6669 13.2235 17.0369 13.7185 17.0199C13.8305 16.8739 13.7965 16.9079 13.9145 16.7719C13.8425 16.5759 13.8145 16.4129 13.7965 16.2719C13.7915 16.2559 13.6005 16.1149 13.6675 15.9399C13.5885 15.8399 13.4375 15.6139 13.3985 15.5079C13.3755 15.5079 13.3535 15.5019 13.3355 15.4959C13.3135 15.4909 13.2805 15.4909 13.2455 15.4909C13.1675 15.6869 13.0825 15.6989 12.9425 15.7439C12.6835 16.2559 12.5935 16.4749 11.8965 16.8859C11.6165 17.1839 11.5145 17.5259 11.5145 17.5199C11.4635 17.6219 11.4755 17.7629 11.5025 17.8409C11.4575 17.9479 11.4755 17.9649 11.4755 17.9649C11.4865 18.0099 11.5315 18.0709 11.5815 18.0769C11.6605 18.0999 11.7505 18.0999 11.7395 18.1949C11.7285 18.3079 11.5765 18.2849 11.5025 18.2679C11.2275 18.2179 11.3175 18.0379 11.1375 18.0939C10.9965 18.1789 10.9415 18.4419 10.7215 18.4029C10.6935 18.3809 10.7045 18.3299 10.7275 18.2849C10.7555 18.2239 10.8115 18.1669 10.7835 18.1439C10.6375 18.1839 10.3505 18.2679 10.3505 18.2679C10.2155 18.3079 10.0695 18.2289 10.2035 18.1439C10.2665 18.1219 10.3565 18.0939 10.4685 18.0259C10.4685 18.0259 10.5305 17.9539 10.4115 17.9869C10.2945 18.0259 10.1195 18.0439 9.99552 18.0319C9.99552 18.0319 9.73852 17.9929 9.70352 17.9759C9.67552 17.9539 9.64252 17.8689 9.72052 17.8749C9.82752 17.8809 10.0865 17.8519 10.2835 17.8079C10.3785 17.7729 10.5645 17.6669 10.6655 17.6219C10.6655 17.6219 10.7785 17.4649 10.8455 17.4309C10.9525 17.3179 11.0365 17.2509 11.1265 17.1329C11.2165 16.9529 11.3175 16.6719 11.6265 16.2269C11.7675 16.0249 11.9415 15.7889 12.1605 15.5809C12.1605 15.5809 12.2225 15.2429 12.5035 15.0079C12.5665 14.8669 12.6605 14.6979 12.7625 14.5459C12.8015 14.4899 12.8355 14.4389 12.8685 14.3779C12.9595 14.2479 13.0545 14.0009 13.3865 13.9669C13.3865 13.9669 13.5335 13.8659 13.5835 13.7929C13.6675 13.7199 13.6575 13.6069 13.7245 13.5339C13.6175 13.4279 13.3585 13.2249 13.3415 12.9609C13.3255 12.6679 13.4255 12.4429 13.6065 12.2689C13.8025 12.0839 14.0045 11.9939 14.2525 12.0109C14.5615 12.0659 14.6185 12.1679 14.7075 12.2689C14.7975 12.3699 14.8375 12.3089 14.8705 12.4149C15.1295 12.4879 15.1185 12.4599 15.1075 12.6509C15.1525 12.7079 15.2135 12.7589 15.2085 12.8649C15.2925 12.6899 15.3155 12.6569 15.5515 12.4659C15.6135 12.3089 15.6525 12.1509 15.7025 11.9879C15.7535 11.8419 15.8155 11.6899 15.8555 11.5779C15.8155 11.2519 15.9165 11.2009 16.0515 10.9139C16.0295 10.8749 16.0355 10.8629 16.0455 10.8019C16.1025 10.6099 16.1815 10.3689 16.2315 10.2059C16.2315 10.2059 16.2485 10.1429 16.3165 10.1429C16.3775 9.94092 16.4735 9.56392 16.4955 9.47992C16.5575 9.27192 16.5245 9.19292 16.4855 9.06992C16.4735 9.02992 16.4795 8.97992 16.4565 8.93392C16.3895 8.81092 16.3165 8.64192 16.2655 8.52392C16.2375 8.45092 16.1865 8.16992 16.1865 8.16992C16.1815 8.10792 16.1815 8.07992 16.1815 8.07992"
				fill="#111111"
			/>
		</symbol>

		{/* Language */}
		<symbol id="language" viewBox="0 0 19 19" fill="none">
			<path
				d="M0 0V10.857h10.857V0H0zm1.357 1.357H9.5V9.5H1.357V1.357zm3.393.679L2.036 8.82h1.357l.543-1.357h2.985l.543 1.357h1.357L6.107 2.036H4.75zm.679 1.696l.95 2.375h-1.9l.95-2.375zm6.785 4.41V9.5h5.429v8.143H9.5v-5.429H8.143V19H19V8.143h-6.786zm.679 2.037v1.357h-2.714v1.357h1.394c.107.94.441 1.704.906 2.3-.698.298-1.539.414-2.3.414v1.357c1.057 0 2.312-.16 3.392-.807 1.08.646 2.336.807 3.393.807v-1.357c-.761 0-1.602-.116-2.3-.415.465-.595.799-1.359.906-2.3h1.394v-1.356H14.25v-1.357h-1.357zm.046 2.714h1.265c-.09.678-.315 1.163-.633 1.528-.317-.365-.543-.85-.632-1.528z"
				fill="currentColor"
			/>
		</symbol>

		{/* Minus */}
		<symbol id="minus" viewBox="0 0 19 19" fill="none">
			<path
				d="M0 0V10.857h10.857V0H0zm1.357 1.357H9.5V9.5H1.357V1.357zm3.393.679L2.036 8.82h1.357l.543-1.357h2.985l.543 1.357h1.357L6.107 2.036H4.75zm.679 1.696l.95 2.375h-1.9l.95-2.375zm6.785 4.41V9.5h5.429v8.143H9.5v-5.429H8.143V19H19V8.143h-6.786zm.679 2.037v1.357h-2.714v1.357h1.394c.107.94.441 1.704.906 2.3-.698.298-1.539.414-2.3.414v1.357c1.057 0 2.312-.16 3.392-.807 1.08.646 2.336.807 3.393.807v-1.357c-.761 0-1.602-.116-2.3-.415.465-.595.799-1.359.906-2.3h1.394v-1.356H14.25v-1.357h-1.357zm.046 2.714h1.265c-.09.678-.315 1.163-.633 1.528-.317-.365-.543-.85-.632-1.528z"
				fill="currentColor"
			/>
		</symbol>

		{/* Nikeapp-White */}
		<symbol id="nikeapp-white" viewBox="0 0 30 30" fill="none">
			<rect width="30" height="30" fill="white" />
			<path
				d="M5.55 13.8C4.65 15.15 4.35 16.65 4.95 17.7C6 19.5 8.55 18.6 10.35 18L25.5 11.4L10.35 15.45C9 15.75 8.1 15.75 7.5 15.3C6 14.1 7.05 12 7.5 11.25C6.75 12.15 6 12.9 5.55 13.8Z"
				fill="black"
			/>
		</symbol>

		{/* NRC-Black */}
		<symbol id="nrc-black" viewBox="0 0 30 30" fill="none">
			<rect width="30" height="30" fill="black" />
			<path
				d="M12 11.1C11.25 11.25 10.5 11.25 10.2 10.95C9.3 10.2 9.9 8.85002 10.2 8.40002C9.75 9.00002 9.3 9.45002 8.85 10.05C8.4 10.95 8.1 11.85 8.55 12.6C9.3 13.65 10.95 13.2 12 12.75L21.9 8.55002L12 11.1Z"
				fill="white"
			/>
			<path
				d="M21.6 21.6C21.3 21.75 20.85 21.9 20.55 21.9C20.1 21.9 19.8 21.75 19.5 21.6C19.2 21.45 18.9 21.15 18.6 21C18.3 20.7 18.15 20.4 18 19.95C17.85 19.5 17.85 19.05 17.85 18.45C17.85 18 17.85 17.55 18 17.1C18.15 16.65 18.3 16.35 18.6 16.05C18.9 15.75 19.2 15.45 19.5 15.3C19.8 15.15 20.25 15 20.7 15C20.85 15 21 15 21.15 15C21.3 15 21.45 15 21.6 15.15V17.1C21.3 16.8 21 16.65 20.85 16.65C20.4 16.65 20.25 16.8 19.95 17.1C19.8 17.4 19.65 17.85 19.65 18.45C19.65 19.05 19.8 19.35 19.95 19.65C20.1 19.95 20.4 20.1 20.85 20.1C21.15 20.1 21.45 19.95 21.75 19.8V21.6H21.6Z"
				fill="white"
			/>
			<path
				d="M15.15 18.15C15.6 18.15 15.9 17.7 15.9 17.25C15.9 16.65 15.6 16.35 15 16.5L15.15 18.15ZM16.05 21.75L15 18.9C15 19.2 15 19.5 15 19.95V21.75H13.2V15H15C16.5 15 17.7 15.45 17.7 17.25C17.7 18 17.4 18.6 16.65 18.9L18 21.75H16.05Z"
				fill="white"
			/>
			<path d="M8.39999 15V21.75H10.2V18.45L11.4 21.75H12.9V15H11.25V18L10.35 15H8.39999Z" fill="white" />
		</symbol>

		{/* NRC-White */}
		<symbol id="nrc-white" viewBox="0 0 30 30" fill="none">
			<rect width="30" height="30" fill="white" />
			<path
				d="M12 11.1C11.25 11.25 10.5 11.25 10.2 10.95C9.3 10.2 9.9 8.85002 10.2 8.40002C9.75 9.00002 9.3 9.45002 8.85 10.05C8.4 10.95 8.1 11.85 8.55 12.6C9.3 13.65 10.95 13.2 12 12.75L21.9 8.55002L12 11.1Z"
				fill="black"
			/>
			<path
				d="M21.6 21.6C21.3 21.75 20.85 21.9 20.55 21.9C20.1 21.9 19.8 21.75 19.5 21.6C19.2 21.45 18.9 21.15 18.6 21C18.3 20.7 18.15 20.4 18 19.95C17.85 19.5 17.85 19.05 17.85 18.45C17.85 18 17.85 17.55 18 17.1C18.15 16.65 18.3 16.35 18.6 16.05C18.9 15.75 19.2 15.45 19.5 15.3C19.8 15.15 20.25 15 20.7 15C20.85 15 21 15 21.15 15C21.3 15 21.45 15 21.6 15.15V17.1C21.3 16.8 21 16.65 20.85 16.65C20.4 16.65 20.25 16.8 19.95 17.1C19.8 17.4 19.65 17.85 19.65 18.45C19.65 19.05 19.8 19.35 19.95 19.65C20.1 19.95 20.4 20.1 20.85 20.1C21.15 20.1 21.45 19.95 21.75 19.8V21.6H21.6Z"
				fill="black"
			/>
			<path
				d="M15.15 18.15C15.6 18.15 15.9 17.7 15.9 17.25C15.9 16.65 15.6 16.35 15 16.5L15.15 18.15ZM16.05 21.75L15 18.9C15 19.2 15 19.5 15 19.95V21.75H13.2V15H15C16.5 15 17.7 15.45 17.7 17.25C17.7 18 17.4 18.6 16.65 18.9L18 21.75H16.05Z"
				fill="black"
			/>
			<path d="M8.39999 15V21.75H10.2V18.45L11.4 21.75H12.9V15H11.25V18L10.35 15H8.39999Z" fill="black" />
		</symbol>

		{/* NTC-Black */}
		<symbol id="ntc-black" viewBox="0 0 30 30" fill="none">
			<rect width="30" height="30" fill="black" />
			<path
				d="M21.3 21.6C21 21.75 20.55 21.9 20.25 21.9C19.8 21.9 19.5 21.75 19.2 21.6C18.9 21.45 18.6 21.15 18.3 21C18 20.7 17.85 20.4 17.7 19.95C17.55 19.5 17.55 19.05 17.55 18.45C17.55 18 17.55 17.55 17.7 17.1C17.85 16.65 18 16.35 18.3 16.05C18.6 15.75 18.9 15.45 19.2 15.3C19.5 15.15 19.95 15 20.4 15C20.55 15 20.7 15 20.85 15C21 15 21.15 15 21.3 15.15V17.1C21 16.8 20.7 16.65 20.55 16.65C20.1 16.65 19.95 16.8 19.65 17.1C19.5 17.4 19.35 17.85 19.35 18.45C19.35 19.05 19.5 19.35 19.65 19.65C19.8 19.95 20.1 20.1 20.55 20.1C20.85 20.1 21.15 19.95 21.45 19.8V21.6H21.3Z"
				fill="white"
			/>
			<path d="M8.55 15V21.75H10.35V18.45L11.55 21.75H13.05V15H11.25V18L10.5 15H8.55Z" fill="white" />
			<path
				d="M12 11.1C11.25 11.25 10.5 11.25 10.2 10.95C9.3 10.2 9.9 8.85002 10.2 8.40002C9.75 9.00002 9.3 9.45002 8.85 10.05C8.4 10.95 8.1 11.85 8.55 12.6C9.3 13.65 10.95 13.2 12 12.75L21.9 8.55002L12 11.1Z"
				fill="white"
			/>
			<path d="M16.35 21.75H14.7V16.65H13.35V15H17.55V16.65H16.35V21.75Z" fill="white" />
		</symbol>

		{/* NTC-White */}
		<symbol id="ntc-white" viewBox="0 0 30 30" fill="none">
			<rect width="30" height="30" fill="white" />
			<path
				d="M21.3 21.6C21 21.75 20.55 21.9 20.25 21.9C19.8 21.9 19.5 21.75 19.2 21.6C18.9 21.45 18.6 21.15 18.3 21C18 20.7 17.85 20.4 17.7 19.95C17.55 19.5 17.55 19.05 17.55 18.45C17.55 18 17.55 17.55 17.7 17.1C17.85 16.65 18 16.35 18.3 16.05C18.6 15.75 18.9 15.45 19.2 15.3C19.5 15.15 19.95 15 20.4 15C20.55 15 20.7 15 20.85 15C21 15 21.15 15 21.3 15.15V17.1C21 16.8 20.7 16.65 20.55 16.65C20.1 16.65 19.95 16.8 19.65 17.1C19.5 17.4 19.35 17.85 19.35 18.45C19.35 19.05 19.5 19.35 19.65 19.65C19.8 19.95 20.1 20.1 20.55 20.1C20.85 20.1 21.15 19.95 21.45 19.8V21.6H21.3Z"
				fill="black"
			/>
			<path d="M8.55 15V21.75H10.35V18.45L11.55 21.75H13.05V15H11.25V18L10.5 15H8.55Z" fill="black" />
			<path
				d="M12 11.1C11.25 11.25 10.5 11.25 10.2 10.95C9.3 10.2 9.9 8.85002 10.2 8.40002C9.75 9.00002 9.3 9.45002 8.85 10.05C8.4 10.95 8.1 11.85 8.55 12.6C9.3 13.65 10.95 13.2 12 12.75L21.9 8.55002L12 11.1Z"
				fill="black"
			/>
			<path d="M16.35 21.75H14.7V16.65H13.35V15H17.55V16.65H16.35V21.75Z" fill="black" />
		</symbol>

		{/* Offline */}
		<symbol id="offline" viewBox="0 0 26 26" fill="none">
			<line x1="4.54693" y1="6.93549" x2="20.8438" y2="23.2324" stroke="black" strokeWidth="1.5" />
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M9.68057 8.89139C10.504 7.98229 11.6938 7.41113 13.0166 7.41113C14.5922 7.41113 15.979 8.21975 16.7842 9.44909L18.039 8.62718C16.9682 6.99252 15.119 5.91113 13.0166 5.91113C11.2796 5.91113 9.7147 6.64964 8.61893 7.82975L9.68057 8.89139ZM8.8577 10.1898L7.73328 9.06541C7.27611 9.91225 7.0166 10.8814 7.0166 11.9111H8.5166C8.5166 11.3015 8.63791 10.7201 8.8577 10.1898Z"
				fill="#111111"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M19.446 20.7781L18.079 19.4111H7.7666C5.69582 19.4111 4.0166 17.7319 4.0166 15.6611C4.0166 13.5903 5.69582 11.9111 7.7666 11.9111V10.4111C4.86739 10.4111 2.5166 12.7619 2.5166 15.6611C2.5166 18.5603 4.86739 20.9111 7.7666 20.9111H18.2666C18.6721 20.9111 19.0669 20.8651 19.446 20.7781ZM14.8666 14.0774C15.4637 12.7979 16.7617 11.9111 18.2666 11.9111C20.3374 11.9111 22.0166 13.5903 22.0166 15.6611C22.0166 17.166 21.1298 18.4641 19.8504 19.0612L20.9585 20.1693C22.4907 19.2523 23.5166 17.5764 23.5166 15.6611C23.5166 12.7619 21.1658 10.4111 18.2666 10.4111C16.3513 10.4111 14.6754 11.4371 13.7584 12.9693L14.8666 14.0774ZM13.1496 14.4818L14.329 15.6611H13.0166C13.0166 15.2556 13.0626 14.8609 13.1496 14.4818Z"
				fill="#111111"
			/>
		</symbol>

		{/* Options */}
		<symbol id="options" viewBox="0 0 6 22" fill="none">
			<path
				clipRule="evenodd"
				d="M5.25 18.5a2.25 2.25 0 11-4.502-.002 2.25 2.25 0 014.502.002zM5.25 11a2.25 2.25 0 11-4.502-.002A2.25 2.25 0 015.25 11zM5.25 3.5a2.25 2.25 0 11-4.502-.002A2.25 2.25 0 015.25 3.5z"
				stroke="currentColor"
				strokeWidth="1.5"
			/>
		</symbol>

		{/* Options-Menu */}
		<symbol id="options-menu" viewBox="0 0 26 26" fill="none">
			<rect width="26" height="26" fill="#111111" />
			<path d="M6.06641 13.4321H19.9331" stroke="white" strokeWidth="1.3" />
			<path d="M6.06641 17.7654H16.4664" stroke="white" strokeWidth="1.3" />
			<path d="M6.06641 9.09874H19.9331" stroke="white" strokeWidth="1.3" />
		</symbol>

		{/* Phone Scan */}
		<symbol id="phone-scan" viewBox="0 0 51 56" fill="none">
			<path
				d="M32.84 21.8505L47.3339 36.0808C48.1358 36.804 48.7848 37.6803 49.2426 38.6579C49.7004 39.6356 49.9578 40.6949 49.9996 41.7735L49.9996 54.7661M30.8593 54.9997L22.3208 42.1145C22.0171 41.6676 21.806 41.1644 21.6999 40.6347C21.5938 40.105 21.5949 39.5595 21.703 39.0302C21.8111 38.5009 22.0241 37.9985 22.3295 37.5528C22.6349 37.107 23.0265 36.7268 23.4811 36.4345C23.9358 36.1423 24.4444 35.9439 24.977 35.8511C25.5095 35.7583 26.0553 35.773 26.5821 35.8942C27.109 36.0154 27.6062 36.2407 28.0445 36.5568C28.4829 36.873 28.8535 37.2736 29.1346 37.7351L34.826 46.5765"
				stroke="black"
				strokeWidth="1.95894"
			/>
			<path
				d="M1.49219 54.7663L1.49219 7.668C1.49219 3.98726 4.4816 1 8.16499 1L25.9591 1C29.6425 1 32.6319 3.98726 32.6319 7.668L32.6319 27.9637L32.6319 43.1477"
				stroke="black"
				strokeWidth="1.95894"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M6.95312 20.7658H14.8901V12.8287H6.95312V20.7658Z"
				stroke="black"
				strokeWidth="1.95894"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M6.95312 32.6708H14.8901V24.7338H6.95312V32.6708Z"
				stroke="black"
				strokeWidth="1.95894"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M18.8594 20.7658H26.7964V12.8287H18.8594V20.7658Z"
				stroke="black"
				strokeWidth="1.95894"
			/>
			<path d="M17.8672 24.7344H23.82" stroke="black" strokeWidth="1.95894" />
			<path d="M25.8047 24.7344H27.7889" stroke="black" strokeWidth="1.95894" />
			<path d="M17.8672 28.7028H19.8514" stroke="black" strokeWidth="1.95894" />
			<path d="M17.8672 32.672H19.8514" stroke="black" strokeWidth="1.95894" />
			<path d="M27.7888 32.6725H22.8281V28.704H27.7888" stroke="black" strokeWidth="1.95894" />
			<path d="M9.21875 39.3044H21.7703" stroke="black" strokeWidth="1.95894" />
			<path d="M11.1484 43.8533L22.7344 43.8533" stroke="black" strokeWidth="1.95894" />
		</symbol>

		{/* Plus Circle */}
		<symbol id="plus_circle" viewBox="0 0 32 32" fill="none">
			<circle cx="16" cy="16" r="15.5" stroke="currentColor" />
			<path
				d="M16.912 15.096V9.248H15.09v5.848H9.245v1.816h5.844v5.847h1.823v-5.848h5.844v-1.815h-5.844z"
				fill="currentColor"
			/>
		</symbol>

		{/* Plus */}
		<symbol id="plus" viewBox="0 0 20 20" fill="none">
			<path
				d="M11.254 8.755V.715H8.748v8.04H.712v2.497h8.036v8.04h2.506v-8.04h8.036V8.755h-8.036z"
				fill="currentColor"
			/>
		</symbol>

		{/* Profile */}
		<symbol id="profile" viewBox="0 0 26 26" fill="none">
			<rect width="26" height="26" fill="#111111" />
			<path
				d="M13.0016 5.20156C10.8477 5.20156 9.10156 6.94771 9.10156 9.10156H10.4016C10.4016 7.66568 11.5657 6.50156 13.0016 6.50156V5.20156ZM9.10156 9.10156C9.10156 11.2554 10.8477 13.0016 13.0016 13.0016V11.7016C11.5657 11.7016 10.4016 10.5374 10.4016 9.10156H9.10156ZM13.0016 13.0016C15.1554 13.0016 16.9016 11.2554 16.9016 9.10156H15.6016C15.6016 10.5374 14.4374 11.7016 13.0016 11.7016V13.0016ZM16.9016 9.10156C16.9016 6.94771 15.1554 5.20156 13.0016 5.20156V6.50156C14.4374 6.50156 15.6016 7.66568 15.6016 9.10156H16.9016ZM6.50156 20.8016V18.2016H5.20156V20.8016H6.50156ZM6.50156 18.2016C6.50156 16.7657 7.66568 15.6016 9.10156 15.6016V14.3016C6.94771 14.3016 5.20156 16.0477 5.20156 18.2016H6.50156ZM9.10156 15.6016H16.9016V14.3016H9.10156V15.6016ZM16.9016 15.6016C18.3374 15.6016 19.5016 16.7657 19.5016 18.2016H20.8016C20.8016 16.0477 19.0554 14.3016 16.9016 14.3016V15.6016ZM19.5016 18.2016V20.8016H20.8016V18.2016H19.5016Z"
				fill="white"
			/>
		</symbol>

		{/* Profile-White */}
		<symbol id="profile-white" viewBox="0 0 26 26" fill="none">
			<rect width="26" height="26" fill="#FFFFFF" />
			<path
				d="M13.0016 5.20156C10.8477 5.20156 9.10156 6.94771 9.10156 9.10156H10.4016C10.4016 7.66568 11.5657 6.50156 13.0016 6.50156V5.20156ZM9.10156 9.10156C9.10156 11.2554 10.8477 13.0016 13.0016 13.0016V11.7016C11.5657 11.7016 10.4016 10.5374 10.4016 9.10156H9.10156ZM13.0016 13.0016C15.1554 13.0016 16.9016 11.2554 16.9016 9.10156H15.6016C15.6016 10.5374 14.4374 11.7016 13.0016 11.7016V13.0016ZM16.9016 9.10156C16.9016 6.94771 15.1554 5.20156 13.0016 5.20156V6.50156C14.4374 6.50156 15.6016 7.66568 15.6016 9.10156H16.9016ZM6.50156 20.8016V18.2016H5.20156V20.8016H6.50156ZM6.50156 18.2016C6.50156 16.7657 7.66568 15.6016 9.10156 15.6016V14.3016C6.94771 14.3016 5.20156 16.0477 5.20156 18.2016H6.50156ZM9.10156 15.6016H16.9016V14.3016H9.10156V15.6016ZM16.9016 15.6016C18.3374 15.6016 19.5016 16.7657 19.5016 18.2016H20.8016C20.8016 16.0477 19.0554 14.3016 16.9016 14.3016V15.6016ZM19.5016 18.2016V20.8016H20.8016V18.2016H19.5016Z"
				fill="#111111"
			/>
		</symbol>

		{/* QR Code */}
		<symbol id="qr-code" viewBox="0 0 26 26" fill="none">
			<rect width="26" height="26" fill="#111111" />
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M6.5 11.702H11.7V6.50195H6.5V11.702Z"
				stroke="white"
				strokeWidth="1.25"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M6.5 19.5018H11.7V14.3018H6.5V19.5018Z"
				stroke="white"
				strokeWidth="1.25"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M14.3008 11.702H19.5008V6.50195H14.3008V11.702Z"
				stroke="white"
				strokeWidth="1.25"
			/>
			<path d="M13.6504 14.3015H17.5504" stroke="white" strokeWidth="1.25" />
			<path d="M18.8516 14.3015H20.1516" stroke="white" strokeWidth="1.25" />
			<path d="M13.6504 16.9016H14.9504" stroke="white" strokeWidth="1.25" />
			<path d="M20.1504 19.5014H16.9004V16.9014H20.1504" stroke="white" strokeWidth="1.25" />
		</symbol>

		{/* QR Code-Black */}
		<symbol id="qr-code-black" viewBox="0 0 26 26" fill="none">
			<rect width="26" height="26" fill="white" />
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M6.49805 11.7015H11.698V6.50151H6.49805V11.7015Z"
				stroke="#111111"
				strokeWidth="1.25"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M6.49805 19.5016H11.698V14.3016H6.49805V19.5016Z"
				stroke="#111111"
				strokeWidth="1.25"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M14.2988 11.7015H19.4988V6.50151H14.2988V11.7015Z"
				stroke="#111111"
				strokeWidth="1.25"
			/>
			<path d="M13.6484 14.3015H17.5484" stroke="#111111" strokeWidth="1.25" />
			<path d="M18.8496 14.3015H20.1496" stroke="#111111" strokeWidth="1.25" />
			<path d="M13.6484 16.9017H14.9484" stroke="#111111" strokeWidth="1.25" />
			<path d="M20.1484 19.5016H16.8984V16.9016H20.1484" stroke="#111111" strokeWidth="1.25" />
		</symbol>

		{/* Refresh */}
		<symbol id="refresh" viewBox="0 0 33 27" fill="none">
			<path
				d="M14.33 3.5c.742-.167 1.495-.25 2.247-.25 3.213.002 6.374 1.504 8.436 4.307a10.54 10.54 0 011.541 9.456l-1.45-3.108a1.127 1.127 0 00-2.041.953L25.5 20.08l.054.143.018.034a1.127 1.127 0 001.708.372l5.069-2.365a1.126 1.126 0 00-.953-2.041l-2.622 1.223c.35-1.185.536-2.413.536-3.65 0-2.624-.807-5.282-2.48-7.57l-.001-.002C24.34 2.835 20.492.998 16.577 1c-.915 0-1.834.1-2.74.304A1.126 1.126 0 1014.33 3.5zM1.605 11.405L4.2 10.194a12.877 12.877 0 00-.527 3.62c0 2.624.808 5.282 2.48 7.569l.002.002c2.49 3.39 6.337 5.228 10.252 5.226.915 0 1.834-.1 2.742-.305a1.126 1.126 0 10-.496-2.197c-.742.168-1.495.25-2.246.25-3.213-.002-6.376-1.504-8.437-4.307a10.53 10.53 0 01-1.537-9.468l1.465 3.139a1.127 1.127 0 002.042-.953L7.45 7.433l-.018-.028a1.119 1.119 0 00-.675-.616 1.122 1.122 0 00-1.105.24l-5 2.334a1.126 1.126 0 00.953 2.042z"
				fill="currentColor"
			/>
		</symbol>

		{/* Reload */}
		<symbol id="reload" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M15 29.9994C15.6904 29.9994 16.25 29.4397 16.25 28.7494C16.25 28.0591 15.6904 27.4994 15 27.4994C11.661 27.4994 8.52202 26.1994 6.16135 23.8384C3.80034 21.4774 2.50001 18.3384 2.50001 14.9994C2.50001 11.6607 3.80034 8.52168 6.16135 6.16068L7.92902 7.92835V2.625H2.62567L4.39368 4.393C1.56034 7.22601 0 10.9927 0 14.9994C0 19.006 1.56034 22.7727 4.39334 25.6057C7.22635 28.4391 10.9934 29.9994 15 29.9994Z"
				fill="currentColor"
			/>
			<path
				d="M28.75 13.7578C28.06 13.7578 27.5 14.3178 27.5 15.0078C27.5 15.6975 28.06 16.2578 28.75 16.2578C29.44 16.2578 30 15.7012 30 15.0078C30 14.3175 29.44 13.7578 28.75 13.7578Z"
				fill="currentColor"
			/>
			<path
				d="M28.9609 9.74414C28.9609 9.05414 28.4009 8.49414 27.7109 8.49414C27.0209 8.49414 26.4609 9.05414 26.4609 9.74414C26.4609 10.4338 27.0209 10.9941 27.7109 10.9941C28.4009 10.9941 28.9609 10.4375 28.9609 9.74414Z"
				fill="currentColor"
			/>
			<path
				d="M24.7227 4.02734C24.0327 4.02734 23.4727 4.58735 23.4727 5.27735C23.4727 5.96702 24.0327 6.52735 24.7227 6.52735C25.4127 6.52735 25.9727 5.97068 25.9727 5.27735C25.9727 4.58735 25.4127 4.02734 24.7227 4.02734Z"
				fill="currentColor"
			/>
			<path
				d="M27.7051 21.5176C28.3951 21.5176 28.9551 20.9609 28.9551 20.2676C28.9551 19.5776 28.3951 19.0176 27.7051 19.0176C27.0151 19.0176 26.4551 19.5776 26.4551 20.2676C26.4551 20.9576 27.0151 21.5176 27.7051 21.5176Z"
				fill="currentColor"
			/>
			<path
				d="M24.7227 23.4746C24.0327 23.4746 23.4727 24.0346 23.4727 24.7246C23.4727 25.4143 24.0327 25.9746 24.7227 25.9746C25.4127 25.9746 25.9727 25.4179 25.9727 24.7246C25.9727 24.0346 25.4127 23.4746 24.7227 23.4746Z"
				fill="currentColor"
			/>
			<path
				d="M20.2637 28.957C20.9537 28.957 21.5137 28.4004 21.5137 27.707C21.5137 27.017 20.9537 26.457 20.2637 26.457C19.5737 26.457 19.0137 27.017 19.0137 27.707C19.0137 28.3967 19.5737 28.957 20.2637 28.957Z"
				fill="currentColor"
			/>
			<path
				d="M15.0007 21.6666C18.6767 21.6666 21.6674 18.6759 21.6674 14.9999C21.6674 12.2082 19.9407 9.81555 17.5007 8.82422V11.6746C18.5103 12.4356 19.1673 13.6409 19.1673 14.9999C19.1673 17.2976 17.2983 19.1666 15.0007 19.1666C12.703 19.1666 10.834 17.2976 10.834 14.9999C10.834 13.6409 11.491 12.4356 12.5007 11.6746V8.82422C10.0607 9.81555 8.33398 12.2082 8.33398 14.9999C8.33398 18.6759 11.3247 21.6666 15.0007 21.6666Z"
				fill="currentColor"
			/>
			<path d="M16.25 6.66602H13.75V14.166H16.25V6.66602Z" fill="currentColor" />
			<path
				d="M19.097 1.81391C18.837 2.45058 19.1403 3.18091 19.777 3.44725C19.9336 3.51058 20.0936 3.54058 20.2536 3.54058C20.7436 3.54058 21.2103 3.25058 21.4103 2.76725C21.6736 2.12724 21.3703 1.39724 20.7303 1.13391C20.0936 0.870574 19.3636 1.17424 19.097 1.81391Z"
				fill="currentColor"
			/>
			<path
				d="M14.9922 2.50001C15.6822 2.50001 16.2422 1.93967 16.2422 1.25C16.2422 0.560001 15.6822 0 14.9922 0C14.2989 0 13.7422 0.560001 13.7422 1.25C13.7422 1.93967 14.3025 2.50001 14.9922 2.50001Z"
				fill="currentColor"
			/>
		</symbol>

		{/* Running Shoe-Black */}
		<symbol id="running-shoe-black" viewBox="0 0 26 26" fill="none">
			<rect width="26" height="26" fill="#111111" />
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M9.87212 13.9755C9.08312 13.8885 9.03612 12.8295 9.04612 12.5005C8.94712 12.9545 8.84912 13.4085 8.82612 13.8545C8.78912 14.5535 8.96912 15.1935 9.39912 15.4215C10.1741 15.8345 10.9661 14.9795 11.4311 14.3655L15.7461 8.66449L10.9691 13.4085C10.5671 13.8045 10.1781 14.0065 9.87212 13.9755Z"
				fill="white"
			/>
			<path
				d="M19.2217 4.5557L21.2537 8.0767C22.2897 9.8697 21.6747 12.1627 19.8817 13.1987L9.30071 19.3077C8.23171 19.9247 7.01771 20.2497 5.78371 20.2497H3.74171C2.24771 20.2497 1.68471 18.2977 2.94871 17.5027C3.73871 17.0057 4.39471 16.3237 4.86171 15.5157L10.3677 5.9757C13.7067 6.8707 17.1377 4.8897 18.0327 1.5517"
				stroke="white"
				strokeWidth="1.5"
			/>
		</symbol>

		{/* Scan-QR-Code */}
		<symbol id="scan-qr-code" viewBox="0 0 52 52" fill="none">
			<path d="M52 0H0V52H52V0Z" fill="white" />
			<path d="M16.6678 5.47749H15.4238V6.72143H16.6678V5.47749Z" fill="#111111" />
			<path d="M19.1541 5.47749H17.9102V6.72143H19.1541V5.47749Z" fill="#111111" />
			<path d="M20.4002 5.47749H19.1562V6.72143H20.4002V5.47749Z" fill="#111111" />
			<path d="M22.8924 5.47749H21.6484V6.72143H22.8924V5.47749Z" fill="#111111" />
			<path d="M24.1326 5.47749H22.8887V6.72143H24.1326V5.47749Z" fill="#111111" />
			<path d="M26.6189 5.47749H25.375V6.72143H26.6189V5.47749Z" fill="#111111" />
			<path d="M27.8631 5.47749H26.6191V6.72143H27.8631V5.47749Z" fill="#111111" />
			<path d="M29.1091 5.47749H27.8652V6.72143H29.1091V5.47749Z" fill="#111111" />
			<path d="M32.8377 5.47749H31.5938V6.72143H32.8377V5.47749Z" fill="#111111" />
			<path d="M34.0838 5.47749H32.8398V6.72143H34.0838V5.47749Z" fill="#111111" />
			<path d="M16.6678 6.72375H15.4238V7.96769H16.6678V6.72375Z" fill="#111111" />
			<path d="M20.4002 6.72375H19.1562V7.96769H20.4002V6.72375Z" fill="#111111" />
			<path d="M22.8924 6.72375H21.6484V7.96769H22.8924V6.72375Z" fill="#111111" />
			<path d="M24.1326 6.72375H22.8887V7.96769H24.1326V6.72375Z" fill="#111111" />
			<path d="M29.1091 6.72375H27.8652V7.96769H29.1091V6.72375Z" fill="#111111" />
			<path d="M30.3494 6.72375H29.1055V7.96769H30.3494V6.72375Z" fill="#111111" />
			<path d="M34.0838 6.72375H32.8398V7.96769H34.0838V6.72375Z" fill="#111111" />
			<path d="M36.5701 6.72375H35.3262V7.96769H36.5701V6.72375Z" fill="#111111" />
			<path d="M16.6678 7.96494H15.4238V9.20887H16.6678V7.96494Z" fill="#111111" />
			<path d="M20.4002 7.96494H19.1562V9.20887H20.4002V7.96494Z" fill="#111111" />
			<path d="M21.6443 7.96494H20.4004V9.20887H21.6443V7.96494Z" fill="#111111" />
			<path d="M22.8924 7.96494H21.6484V9.20887H22.8924V7.96494Z" fill="#111111" />
			<path d="M24.1326 7.96494H22.8887V9.20887H24.1326V7.96494Z" fill="#111111" />
			<path d="M25.3767 7.96494H24.1328V9.20887H25.3767V7.96494Z" fill="#111111" />
			<path d="M26.6189 7.96494H25.375V9.20887H26.6189V7.96494Z" fill="#111111" />
			<path d="M31.5955 7.96494H30.3516V9.20887H31.5955V7.96494Z" fill="#111111" />
			<path d="M32.8377 7.96494H31.5938V9.20887H32.8377V7.96494Z" fill="#111111" />
			<path d="M35.3279 7.96494H34.084V9.20887H35.3279V7.96494Z" fill="#111111" />
			<path d="M19.1541 9.20779H17.9102V10.4517H19.1541V9.20779Z" fill="#111111" />
			<path d="M24.1326 9.20779H22.8887V10.4517H24.1326V9.20779Z" fill="#111111" />
			<path d="M26.6189 9.20779H25.375V10.4517H26.6189V9.20779Z" fill="#111111" />
			<path d="M29.1091 9.20779H27.8652V10.4517H29.1091V9.20779Z" fill="#111111" />
			<path d="M30.3494 9.20779H29.1055V10.4517H30.3494V9.20779Z" fill="#111111" />
			<path d="M31.5955 9.20779H30.3516V10.4517H31.5955V9.20779Z" fill="#111111" />
			<path d="M32.8377 9.20779H31.5938V10.4517H32.8377V9.20779Z" fill="#111111" />
			<path d="M34.0838 9.20779H32.8398V10.4517H34.0838V9.20779Z" fill="#111111" />
			<path d="M35.3279 9.20779H34.084V10.4517H35.3279V9.20779Z" fill="#111111" />
			<path d="M16.6678 10.4507H15.4238V11.6946H16.6678V10.4507Z" fill="#111111" />
			<path d="M20.4002 10.4507H19.1562V11.6946H20.4002V10.4507Z" fill="#111111" />
			<path d="M21.6443 10.4507H20.4004V11.6946H21.6443V10.4507Z" fill="#111111" />
			<path d="M22.8924 10.4507H21.6484V11.6946H22.8924V10.4507Z" fill="#111111" />
			<path d="M25.3767 10.4507H24.1328V11.6946H25.3767V10.4507Z" fill="#111111" />
			<path d="M26.6189 10.4507H25.375V11.6946H26.6189V10.4507Z" fill="#111111" />
			<path d="M32.8377 10.4507H31.5938V11.6946H32.8377V10.4507Z" fill="#111111" />
			<path d="M34.0838 10.4507H32.8398V11.6946H34.0838V10.4507Z" fill="#111111" />
			<path d="M36.5701 10.4507H35.3262V11.6946H36.5701V10.4507Z" fill="#111111" />
			<path d="M17.9119 11.6969H16.668V12.9409H17.9119V11.6969Z" fill="#111111" />
			<path d="M20.4002 11.6969H19.1562V12.9409H20.4002V11.6969Z" fill="#111111" />
			<path d="M22.8924 11.6969H21.6484V12.9409H22.8924V11.6969Z" fill="#111111" />
			<path d="M24.1326 11.6969H22.8887V12.9409H24.1326V11.6969Z" fill="#111111" />
			<path d="M25.3767 11.6969H24.1328V12.9409H25.3767V11.6969Z" fill="#111111" />
			<path d="M26.6189 11.6969H25.375V12.9409H26.6189V11.6969Z" fill="#111111" />
			<path d="M27.8631 11.6969H26.6191V12.9409H27.8631V11.6969Z" fill="#111111" />
			<path d="M30.3494 11.6969H29.1055V12.9409H30.3494V11.6969Z" fill="#111111" />
			<path d="M34.0838 11.6969H32.8398V12.9409H34.0838V11.6969Z" fill="#111111" />
			<path d="M35.3279 11.6969H34.084V12.9409H35.3279V11.6969Z" fill="#111111" />
			<path d="M16.6678 12.9381H15.4238V14.182H16.6678V12.9381Z" fill="#111111" />
			<path d="M19.1541 12.9381H17.9102V14.182H19.1541V12.9381Z" fill="#111111" />
			<path d="M21.6443 12.9381H20.4004V14.182H21.6443V12.9381Z" fill="#111111" />
			<path d="M24.1326 12.9381H22.8887V14.182H24.1326V12.9381Z" fill="#111111" />
			<path d="M26.6189 12.9381H25.375V14.182H26.6189V12.9381Z" fill="#111111" />
			<path d="M29.1091 12.9381H27.8652V14.182H29.1091V12.9381Z" fill="#111111" />
			<path d="M31.5955 12.9381H30.3516V14.182H31.5955V12.9381Z" fill="#111111" />
			<path d="M34.0838 12.9381H32.8398V14.182H34.0838V12.9381Z" fill="#111111" />
			<path d="M36.5701 12.9381H35.3262V14.182H36.5701V12.9381Z" fill="#111111" />
			<path d="M17.9119 14.181H16.668V15.4249H17.9119V14.181Z" fill="#111111" />
			<path d="M19.1541 14.181H17.9102V15.4249H19.1541V14.181Z" fill="#111111" />
			<path d="M20.4002 14.181H19.1562V15.4249H20.4002V14.181Z" fill="#111111" />
			<path d="M22.8924 14.181H21.6484V15.4249H22.8924V14.181Z" fill="#111111" />
			<path d="M25.3767 14.181H24.1328V15.4249H25.3767V14.181Z" fill="#111111" />
			<path d="M26.6189 14.181H25.375V15.4249H26.6189V14.181Z" fill="#111111" />
			<path d="M34.0838 14.181H32.8398V15.4249H34.0838V14.181Z" fill="#111111" />
			<path d="M36.5701 14.181H35.3262V15.4249H36.5701V14.181Z" fill="#111111" />
			<path d="M6.71854 15.4272H5.47461V16.6712H6.71854V15.4272Z" fill="#111111" />
			<path d="M10.4471 15.4272H9.20312V16.6712H10.4471V15.4272Z" fill="#111111" />
			<path d="M11.6912 15.4272H10.4473V16.6712H11.6912V15.4272Z" fill="#111111" />
			<path d="M12.9353 15.4272H11.6914V16.6712H12.9353V15.4272Z" fill="#111111" />
			<path d="M14.1834 15.4272H12.9395V16.6712H14.1834V15.4272Z" fill="#111111" />
			<path d="M15.4236 15.4272H14.1797V16.6712H15.4236V15.4272Z" fill="#111111" />
			<path d="M16.6678 15.4272H15.4238V16.6712H16.6678V15.4272Z" fill="#111111" />
			<path d="M17.9119 15.4272H16.668V16.6712H17.9119V15.4272Z" fill="#111111" />
			<path d="M24.1326 15.4272H22.8887V16.6712H24.1326V15.4272Z" fill="#111111" />
			<path d="M27.8631 15.4272H26.6191V16.6712H27.8631V15.4272Z" fill="#111111" />
			<path d="M29.1091 15.4272H27.8652V16.6712H29.1091V15.4272Z" fill="#111111" />
			<path d="M35.3279 15.4272H34.084V16.6712H35.3279V15.4272Z" fill="#111111" />
			<path d="M36.5701 15.4272H35.3262V16.6712H36.5701V15.4272Z" fill="#111111" />
			<path d="M37.8162 15.4272H36.5723V16.6712H37.8162V15.4272Z" fill="#111111" />
			<path d="M41.5467 15.4272H40.3027V16.6712H41.5467V15.4272Z" fill="#111111" />
			<path d="M44.0369 15.4272H42.793V16.6712H44.0369V15.4272Z" fill="#111111" />
			<path d="M45.2771 15.4272H44.0332V16.6712H45.2771V15.4272Z" fill="#111111" />
			<path d="M46.5232 15.4272H45.2793V16.6712H46.5232V15.4272Z" fill="#111111" />
			<path d="M7.96659 16.6701H6.72266V17.914H7.96659V16.6701Z" fill="#111111" />
			<path d="M10.4471 16.6701H9.20312V17.914H10.4471V16.6701Z" fill="#111111" />
			<path d="M12.9353 16.6701H11.6914V17.914H12.9353V16.6701Z" fill="#111111" />
			<path d="M15.4236 16.6701H14.1797V17.914H15.4236V16.6701Z" fill="#111111" />
			<path d="M16.6678 16.6701H15.4238V17.914H16.6678V16.6701Z" fill="#111111" />
			<path d="M17.9119 16.6701H16.668V17.914H17.9119V16.6701Z" fill="#111111" />
			<path d="M20.4002 16.6701H19.1562V17.914H20.4002V16.6701Z" fill="#111111" />
			<path d="M21.6443 16.6701H20.4004V17.914H21.6443V16.6701Z" fill="#111111" />
			<path d="M22.8924 16.6701H21.6484V17.914H22.8924V16.6701Z" fill="#111111" />
			<path d="M24.1326 16.6701H22.8887V17.914H24.1326V16.6701Z" fill="#111111" />
			<path d="M25.3767 16.6701H24.1328V17.914H25.3767V16.6701Z" fill="#111111" />
			<path d="M27.8631 16.6701H26.6191V17.914H27.8631V16.6701Z" fill="#111111" />
			<path d="M29.1091 16.6701H27.8652V17.914H29.1091V16.6701Z" fill="#111111" />
			<path d="M30.3494 16.6701H29.1055V17.914H30.3494V16.6701Z" fill="#111111" />
			<path d="M35.3279 16.6701H34.084V17.914H35.3279V16.6701Z" fill="#111111" />
			<path d="M36.5701 16.6701H35.3262V17.914H36.5701V16.6701Z" fill="#111111" />
			<path d="M41.5467 16.6701H40.3027V17.914H41.5467V16.6701Z" fill="#111111" />
			<path d="M42.7928 16.6701H41.5488V17.914H42.7928V16.6701Z" fill="#111111" />
			<path d="M44.0369 16.6701H42.793V17.914H44.0369V16.6701Z" fill="#111111" />
			<path d="M6.71854 17.9181H5.47461V19.162H6.71854V17.9181Z" fill="#111111" />
			<path d="M9.20683 17.9181H7.96289V19.162H9.20683V17.9181Z" fill="#111111" />
			<path d="M10.4471 17.9181H9.20312V19.162H10.4471V17.9181Z" fill="#111111" />
			<path d="M14.1834 17.9181H12.9395V19.162H14.1834V17.9181Z" fill="#111111" />
			<path d="M15.4236 17.9181H14.1797V19.162H15.4236V17.9181Z" fill="#111111" />
			<path d="M16.6678 17.9181H15.4238V19.162H16.6678V17.9181Z" fill="#111111" />
			<path d="M17.9119 17.9181H16.668V19.162H17.9119V17.9181Z" fill="#111111" />
			<path d="M22.8924 17.9181H21.6484V19.162H22.8924V17.9181Z" fill="#111111" />
			<path d="M25.3767 17.9181H24.1328V19.162H25.3767V17.9181Z" fill="#111111" />
			<path d="M32.8377 17.9181H31.5938V19.162H32.8377V17.9181Z" fill="#111111" />
			<path d="M34.0838 17.9181H32.8398V19.162H34.0838V17.9181Z" fill="#111111" />
			<path d="M35.3279 17.9181H34.084V19.162H35.3279V17.9181Z" fill="#111111" />
			<path d="M39.0603 17.9181H37.8164V19.162H39.0603V17.9181Z" fill="#111111" />
			<path d="M41.5467 17.9181H40.3027V19.162H41.5467V17.9181Z" fill="#111111" />
			<path d="M42.7928 17.9181H41.5488V19.162H42.7928V17.9181Z" fill="#111111" />
			<path d="M44.0369 17.9181H42.793V19.162H44.0369V17.9181Z" fill="#111111" />
			<path d="M45.2771 17.9181H44.0332V19.162H45.2771V17.9181Z" fill="#111111" />
			<path d="M46.5232 17.9181H45.2793V19.162H46.5232V17.9181Z" fill="#111111" />
			<path d="M7.96659 19.1575H6.72266V20.4015H7.96659V19.1575Z" fill="#111111" />
			<path d="M10.4471 19.1575H9.20312V20.4015H10.4471V19.1575Z" fill="#111111" />
			<path d="M19.1541 19.1575H17.9102V20.4015H19.1541V19.1575Z" fill="#111111" />
			<path d="M20.4002 19.1575H19.1562V20.4015H20.4002V19.1575Z" fill="#111111" />
			<path d="M21.6443 19.1575H20.4004V20.4015H21.6443V19.1575Z" fill="#111111" />
			<path d="M22.8924 19.1575H21.6484V20.4015H22.8924V19.1575Z" fill="#111111" />
			<path d="M26.6189 19.1575H25.375V20.4015H26.6189V19.1575Z" fill="#111111" />
			<path d="M29.1091 19.1575H27.8652V20.4015H29.1091V19.1575Z" fill="#111111" />
			<path d="M30.3494 19.1575H29.1055V20.4015H30.3494V19.1575Z" fill="#111111" />
			<path d="M36.5701 19.1575H35.3262V20.4015H36.5701V19.1575Z" fill="#111111" />
			<path d="M40.3025 19.1575H39.0586V20.4015H40.3025V19.1575Z" fill="#111111" />
			<path d="M44.0369 19.1575H42.793V20.4015H44.0369V19.1575Z" fill="#111111" />
			<path d="M45.2771 19.1575H44.0332V20.4015H45.2771V19.1575Z" fill="#111111" />
			<path d="M46.5232 19.1575H45.2793V20.4015H46.5232V19.1575Z" fill="#111111" />
			<path d="M7.96659 20.4038H6.72266V21.6477H7.96659V20.4038Z" fill="#111111" />
			<path d="M9.20683 20.4038H7.96289V21.6477H9.20683V20.4038Z" fill="#111111" />
			<path d="M10.4471 20.4038H9.20312V21.6477H10.4471V20.4038Z" fill="#111111" />
			<path d="M11.6912 20.4038H10.4473V21.6477H11.6912V20.4038Z" fill="#111111" />
			<path d="M14.1834 20.4038H12.9395V21.6477H14.1834V20.4038Z" fill="#111111" />
			<path d="M15.4236 20.4038H14.1797V21.6477H15.4236V20.4038Z" fill="#111111" />
			<path d="M16.6678 20.4038H15.4238V21.6477H16.6678V20.4038Z" fill="#111111" />
			<path d="M19.1541 20.4038H17.9102V21.6477H19.1541V20.4038Z" fill="#111111" />
			<path d="M20.4002 20.4038H19.1562V21.6477H20.4002V20.4038Z" fill="#111111" />
			<path d="M22.8924 20.4038H21.6484V21.6477H22.8924V20.4038Z" fill="#111111" />
			<path d="M25.3767 20.4038H24.1328V21.6477H25.3767V20.4038Z" fill="#111111" />
			<path d="M27.8631 20.4038H26.6191V21.6477H27.8631V20.4038Z" fill="#111111" />
			<path d="M30.3494 20.4038H29.1055V21.6477H30.3494V20.4038Z" fill="#111111" />
			<path d="M34.0838 20.4038H32.8398V21.6477H34.0838V20.4038Z" fill="#111111" />
			<path d="M35.3279 20.4038H34.084V21.6477H35.3279V20.4038Z" fill="#111111" />
			<path d="M37.8162 20.4038H36.5723V21.6477H37.8162V20.4038Z" fill="#111111" />
			<path d="M39.0603 20.4038H37.8164V21.6477H39.0603V20.4038Z" fill="#111111" />
			<path d="M45.2771 20.4038H44.0332V21.6477H45.2771V20.4038Z" fill="#111111" />
			<path d="M6.71854 21.6501H5.47461V22.894H6.71854V21.6501Z" fill="#111111" />
			<path d="M12.9353 21.6501H11.6914V22.894H12.9353V21.6501Z" fill="#111111" />
			<path d="M15.4236 21.6501H14.1797V22.894H15.4236V21.6501Z" fill="#111111" />
			<path d="M16.6678 21.6501H15.4238V22.894H16.6678V21.6501Z" fill="#111111" />
			<path d="M17.9119 21.6501H16.668V22.894H17.9119V21.6501Z" fill="#111111" />
			<path d="M19.1541 21.6501H17.9102V22.894H19.1541V21.6501Z" fill="#111111" />
			<path d="M20.4002 21.6501H19.1562V22.894H20.4002V21.6501Z" fill="#111111" />
			<path d="M21.6443 21.6501H20.4004V22.894H21.6443V21.6501Z" fill="#111111" />
			<path d="M22.8924 21.6501H21.6484V22.894H22.8924V21.6501Z" fill="#111111" />
			<path d="M24.1326 21.6501H22.8887V22.894H24.1326V21.6501Z" fill="#111111" />
			<path d="M27.8631 21.6501H26.6191V22.894H27.8631V21.6501Z" fill="#111111" />
			<path d="M29.1091 21.6501H27.8652V22.894H29.1091V21.6501Z" fill="#111111" />
			<path d="M30.3494 21.6501H29.1055V22.894H30.3494V21.6501Z" fill="#111111" />
			<path d="M31.5955 21.6501H30.3516V22.894H31.5955V21.6501Z" fill="#111111" />
			<path d="M34.0838 21.6501H32.8398V22.894H34.0838V21.6501Z" fill="#111111" />
			<path d="M35.3279 21.6501H34.084V22.894H35.3279V21.6501Z" fill="#111111" />
			<path d="M36.5701 21.6501H35.3262V22.894H36.5701V21.6501Z" fill="#111111" />
			<path d="M42.7928 21.6501H41.5488V22.894H42.7928V21.6501Z" fill="#111111" />
			<path d="M44.0369 21.6501H42.793V22.894H44.0369V21.6501Z" fill="#111111" />
			<path d="M6.71854 22.8912H5.47461V24.1352H6.71854V22.8912Z" fill="#111111" />
			<path d="M7.96659 22.8912H6.72266V24.1352H7.96659V22.8912Z" fill="#111111" />
			<path d="M9.20683 22.8912H7.96289V24.1352H9.20683V22.8912Z" fill="#111111" />
			<path d="M10.4471 22.8912H9.20312V24.1352H10.4471V22.8912Z" fill="#111111" />
			<path d="M14.1834 22.8912H12.9395V24.1352H14.1834V22.8912Z" fill="#111111" />
			<path d="M15.4236 22.8912H14.1797V24.1352H15.4236V22.8912Z" fill="#111111" />
			<path d="M17.9119 22.8912H16.668V24.1352H17.9119V22.8912Z" fill="#111111" />
			<path d="M19.1541 22.8912H17.9102V24.1352H19.1541V22.8912Z" fill="#111111" />
			<path d="M21.6443 22.8912H20.4004V24.1352H21.6443V22.8912Z" fill="#111111" />
			<path d="M24.1326 22.8912H22.8887V24.1352H24.1326V22.8912Z" fill="#111111" />
			<path d="M25.3767 22.8912H24.1328V24.1352H25.3767V22.8912Z" fill="#111111" />
			<path d="M27.8631 22.8912H26.6191V24.1352H27.8631V22.8912Z" fill="#111111" />
			<path d="M30.3494 22.8912H29.1055V24.1352H30.3494V22.8912Z" fill="#111111" />
			<path d="M31.5955 22.8912H30.3516V24.1352H31.5955V22.8912Z" fill="#111111" />
			<path d="M32.8377 22.8912H31.5938V24.1352H32.8377V22.8912Z" fill="#111111" />
			<path d="M34.0838 22.8912H32.8398V24.1352H34.0838V22.8912Z" fill="#111111" />
			<path d="M39.0603 22.8912H37.8164V24.1352H39.0603V22.8912Z" fill="#111111" />
			<path d="M41.5467 22.8912H40.3027V24.1352H41.5467V22.8912Z" fill="#111111" />
			<path d="M42.7928 22.8912H41.5488V24.1352H42.7928V22.8912Z" fill="#111111" />
			<path d="M44.0369 22.8912H42.793V24.1352H44.0369V22.8912Z" fill="#111111" />
			<path d="M9.20683 24.1341H7.96289V25.378H9.20683V24.1341Z" fill="#111111" />
			<path d="M11.6912 24.1341H10.4473V25.378H11.6912V24.1341Z" fill="#111111" />
			<path d="M15.4236 24.1341H14.1797V25.378H15.4236V24.1341Z" fill="#111111" />
			<path d="M16.6678 24.1341H15.4238V25.378H16.6678V24.1341Z" fill="#111111" />
			<path d="M19.1541 24.1341H17.9102V25.378H19.1541V24.1341Z" fill="#111111" />
			<path d="M20.4002 24.1341H19.1562V25.378H20.4002V24.1341Z" fill="#111111" />
			<path d="M21.6443 24.1341H20.4004V25.378H21.6443V24.1341Z" fill="#111111" />
			<path d="M22.8924 24.1341H21.6484V25.378H22.8924V24.1341Z" fill="#111111" />
			<path d="M24.1326 24.1341H22.8887V25.378H24.1326V24.1341Z" fill="#111111" />
			<path d="M26.6189 24.1341H25.375V25.378H26.6189V24.1341Z" fill="#111111" />
			<path d="M31.5955 24.1341H30.3516V25.378H31.5955V24.1341Z" fill="#111111" />
			<path d="M34.0838 24.1341H32.8398V25.378H34.0838V24.1341Z" fill="#111111" />
			<path d="M37.8162 24.1341H36.5723V25.378H37.8162V24.1341Z" fill="#111111" />
			<path d="M41.5467 24.1341H40.3027V25.378H41.5467V24.1341Z" fill="#111111" />
			<path d="M44.0369 24.1341H42.793V25.378H44.0369V24.1341Z" fill="#111111" />
			<path d="M46.5232 24.1341H45.2793V25.378H46.5232V24.1341Z" fill="#111111" />
			<path d="M6.71854 25.3768H5.47461V26.6207H6.71854V25.3768Z" fill="#111111" />
			<path d="M7.96659 25.3768H6.72266V26.6207H7.96659V25.3768Z" fill="#111111" />
			<path d="M11.6912 25.3768H10.4473V26.6207H11.6912V25.3768Z" fill="#111111" />
			<path d="M14.1834 25.3768H12.9395V26.6207H14.1834V25.3768Z" fill="#111111" />
			<path d="M16.6678 25.3768H15.4238V26.6207H16.6678V25.3768Z" fill="#111111" />
			<path d="M19.1541 25.3768H17.9102V26.6207H19.1541V25.3768Z" fill="#111111" />
			<path d="M20.4002 25.3768H19.1562V26.6207H20.4002V25.3768Z" fill="#111111" />
			<path d="M24.1326 25.3768H22.8887V26.6207H24.1326V25.3768Z" fill="#111111" />
			<path d="M25.3767 25.3768H24.1328V26.6207H25.3767V25.3768Z" fill="#111111" />
			<path d="M26.6189 25.3768H25.375V26.6207H26.6189V25.3768Z" fill="#111111" />
			<path d="M31.5955 25.3768H30.3516V26.6207H31.5955V25.3768Z" fill="#111111" />
			<path d="M34.0838 25.3768H32.8398V26.6207H34.0838V25.3768Z" fill="#111111" />
			<path d="M35.3279 25.3768H34.084V26.6207H35.3279V25.3768Z" fill="#111111" />
			<path d="M37.8162 25.3768H36.5723V26.6207H37.8162V25.3768Z" fill="#111111" />
			<path d="M39.0603 25.3768H37.8164V26.6207H39.0603V25.3768Z" fill="#111111" />
			<path d="M40.3025 25.3768H39.0586V26.6207H40.3025V25.3768Z" fill="#111111" />
			<path d="M41.5467 25.3768H40.3027V26.6207H41.5467V25.3768Z" fill="#111111" />
			<path d="M42.7928 25.3768H41.5488V26.6207H42.7928V25.3768Z" fill="#111111" />
			<path d="M6.71854 26.6232H5.47461V27.8672H6.71854V26.6232Z" fill="#111111" />
			<path d="M9.20683 26.6232H7.96289V27.8672H9.20683V26.6232Z" fill="#111111" />
			<path d="M11.6912 26.6232H10.4473V27.8672H11.6912V26.6232Z" fill="#111111" />
			<path d="M12.9353 26.6232H11.6914V27.8672H12.9353V26.6232Z" fill="#111111" />
			<path d="M15.4236 26.6232H14.1797V27.8672H15.4236V26.6232Z" fill="#111111" />
			<path d="M16.6678 26.6232H15.4238V27.8672H16.6678V26.6232Z" fill="#111111" />
			<path d="M19.1541 26.6232H17.9102V27.8672H19.1541V26.6232Z" fill="#111111" />
			<path d="M20.4002 26.6232H19.1562V27.8672H20.4002V26.6232Z" fill="#111111" />
			<path d="M22.8924 26.6232H21.6484V27.8672H22.8924V26.6232Z" fill="#111111" />
			<path d="M24.1326 26.6232H22.8887V27.8672H24.1326V26.6232Z" fill="#111111" />
			<path d="M25.3767 26.6232H24.1328V27.8672H25.3767V26.6232Z" fill="#111111" />
			<path d="M27.8631 26.6232H26.6191V27.8672H27.8631V26.6232Z" fill="#111111" />
			<path d="M30.3494 26.6232H29.1055V27.8672H30.3494V26.6232Z" fill="#111111" />
			<path d="M31.5955 26.6232H30.3516V27.8672H31.5955V26.6232Z" fill="#111111" />
			<path d="M39.0603 26.6232H37.8164V27.8672H39.0603V26.6232Z" fill="#111111" />
			<path d="M41.5467 26.6232H40.3027V27.8672H41.5467V26.6232Z" fill="#111111" />
			<path d="M44.0369 26.6232H42.793V27.8672H44.0369V26.6232Z" fill="#111111" />
			<path d="M46.5232 26.6232H45.2793V27.8672H46.5232V26.6232Z" fill="#111111" />
			<path d="M11.6912 27.8678H10.4473V29.1117H11.6912V27.8678Z" fill="#111111" />
			<path d="M14.1834 27.8678H12.9395V29.1117H14.1834V27.8678Z" fill="#111111" />
			<path d="M15.4236 27.8678H14.1797V29.1117H15.4236V27.8678Z" fill="#111111" />
			<path d="M21.6443 27.8678H20.4004V29.1117H21.6443V27.8678Z" fill="#111111" />
			<path d="M22.8924 27.8678H21.6484V29.1117H22.8924V27.8678Z" fill="#111111" />
			<path d="M24.1326 27.8678H22.8887V29.1117H24.1326V27.8678Z" fill="#111111" />
			<path d="M25.3767 27.8678H24.1328V29.1117H25.3767V27.8678Z" fill="#111111" />
			<path d="M27.8631 27.8678H26.6191V29.1117H27.8631V27.8678Z" fill="#111111" />
			<path d="M29.1091 27.8678H27.8652V29.1117H29.1091V27.8678Z" fill="#111111" />
			<path d="M30.3494 27.8678H29.1055V29.1117H30.3494V27.8678Z" fill="#111111" />
			<path d="M31.5955 27.8678H30.3516V29.1117H31.5955V27.8678Z" fill="#111111" />
			<path d="M35.3279 27.8678H34.084V29.1117H35.3279V27.8678Z" fill="#111111" />
			<path d="M36.5701 27.8678H35.3262V29.1117H36.5701V27.8678Z" fill="#111111" />
			<path d="M37.8162 27.8678H36.5723V29.1117H37.8162V27.8678Z" fill="#111111" />
			<path d="M40.3025 27.8678H39.0586V29.1117H40.3025V27.8678Z" fill="#111111" />
			<path d="M42.7928 27.8678H41.5488V29.1117H42.7928V27.8678Z" fill="#111111" />
			<path d="M44.0369 27.8678H42.793V29.1117H44.0369V27.8678Z" fill="#111111" />
			<path d="M46.5232 27.8678H45.2793V29.1117H46.5232V27.8678Z" fill="#111111" />
			<path d="M7.96659 29.1107H6.72266V30.3546H7.96659V29.1107Z" fill="#111111" />
			<path d="M10.4471 29.1107H9.20312V30.3546H10.4471V29.1107Z" fill="#111111" />
			<path d="M11.6912 29.1107H10.4473V30.3546H11.6912V29.1107Z" fill="#111111" />
			<path d="M15.4236 29.1107H14.1797V30.3546H15.4236V29.1107Z" fill="#111111" />
			<path d="M36.5701 29.1107H35.3262V30.3546H36.5701V29.1107Z" fill="#111111" />
			<path d="M39.0603 29.1107H37.8164V30.3546H39.0603V29.1107Z" fill="#111111" />
			<path d="M41.5467 29.1107H40.3027V30.3546H41.5467V29.1107Z" fill="#111111" />
			<path d="M42.7928 29.1107H41.5488V30.3546H42.7928V29.1107Z" fill="#111111" />
			<path d="M44.0369 29.1107H42.793V30.3546H44.0369V29.1107Z" fill="#111111" />
			<path d="M46.5232 29.1107H45.2793V30.3546H46.5232V29.1107Z" fill="#111111" />
			<path d="M7.96659 30.3533H6.72266V31.5972H7.96659V30.3533Z" fill="#111111" />
			<path d="M10.4471 30.3533H9.20312V31.5972H10.4471V30.3533Z" fill="#111111" />
			<path d="M11.6912 30.3533H10.4473V31.5972H11.6912V30.3533Z" fill="#111111" />
			<path d="M14.1834 30.3533H12.9395V31.5972H14.1834V30.3533Z" fill="#111111" />
			<path d="M15.4236 30.3533H14.1797V31.5972H15.4236V30.3533Z" fill="#111111" />
			<path d="M17.9119 30.3533H16.668V31.5972H17.9119V30.3533Z" fill="#111111" />
			<path d="M19.1541 30.3533H17.9102V31.5972H19.1541V30.3533Z" fill="#111111" />
			<path d="M20.4002 30.3533H19.1562V31.5972H20.4002V30.3533Z" fill="#111111" />
			<path d="M21.6443 30.3533H20.4004V31.5972H21.6443V30.3533Z" fill="#111111" />
			<path d="M24.1326 30.3533H22.8887V31.5972H24.1326V30.3533Z" fill="#111111" />
			<path d="M25.3767 30.3533H24.1328V31.5972H25.3767V30.3533Z" fill="#111111" />
			<path d="M26.6189 30.3533H25.375V31.5972H26.6189V30.3533Z" fill="#111111" />
			<path d="M29.1091 30.3533H27.8652V31.5972H29.1091V30.3533Z" fill="#111111" />
			<path d="M32.8377 30.3533H31.5938V31.5972H32.8377V30.3533Z" fill="#111111" />
			<path d="M34.0838 30.3533H32.8398V31.5972H34.0838V30.3533Z" fill="#111111" />
			<path d="M37.8162 30.3533H36.5723V31.5972H37.8162V30.3533Z" fill="#111111" />
			<path d="M42.7928 30.3533H41.5488V31.5972H42.7928V30.3533Z" fill="#111111" />
			<path d="M45.2771 30.3533H44.0332V31.5972H45.2771V30.3533Z" fill="#111111" />
			<path d="M46.5232 30.3533H45.2793V31.5972H46.5232V30.3533Z" fill="#111111" />
			<path d="M6.71854 31.5998H5.47461V32.8437H6.71854V31.5998Z" fill="#111111" />
			<path d="M7.96659 31.5998H6.72266V32.8437H7.96659V31.5998Z" fill="#111111" />
			<path d="M9.20683 31.5998H7.96289V32.8437H9.20683V31.5998Z" fill="#111111" />
			<path d="M10.4471 31.5998H9.20312V32.8437H10.4471V31.5998Z" fill="#111111" />
			<path d="M11.6912 31.5998H10.4473V32.8437H11.6912V31.5998Z" fill="#111111" />
			<path d="M15.4236 31.5998H14.1797V32.8437H15.4236V31.5998Z" fill="#111111" />
			<path d="M20.4002 31.5998H19.1562V32.8437H20.4002V31.5998Z" fill="#111111" />
			<path d="M21.6443 31.5998H20.4004V32.8437H21.6443V31.5998Z" fill="#111111" />
			<path d="M24.1326 31.5998H22.8887V32.8437H24.1326V31.5998Z" fill="#111111" />
			<path d="M34.0838 31.5998H32.8398V32.8437H34.0838V31.5998Z" fill="#111111" />
			<path d="M35.3279 31.5998H34.084V32.8437H35.3279V31.5998Z" fill="#111111" />
			<path d="M36.5701 31.5998H35.3262V32.8437H36.5701V31.5998Z" fill="#111111" />
			<path d="M37.8162 31.5998H36.5723V32.8437H37.8162V31.5998Z" fill="#111111" />
			<path d="M41.5467 31.5998H40.3027V32.8437H41.5467V31.5998Z" fill="#111111" />
			<path d="M42.7928 31.5998H41.5488V32.8437H42.7928V31.5998Z" fill="#111111" />
			<path d="M6.71854 32.8427H5.47461V34.0866H6.71854V32.8427Z" fill="#111111" />
			<path d="M9.20683 32.8427H7.96289V34.0866H9.20683V32.8427Z" fill="#111111" />
			<path d="M10.4471 32.8427H9.20312V34.0866H10.4471V32.8427Z" fill="#111111" />
			<path d="M11.6912 32.8427H10.4473V34.0866H11.6912V32.8427Z" fill="#111111" />
			<path d="M12.9353 32.8427H11.6914V34.0866H12.9353V32.8427Z" fill="#111111" />
			<path d="M14.1834 32.8427H12.9395V34.0866H14.1834V32.8427Z" fill="#111111" />
			<path d="M17.9119 32.8427H16.668V34.0866H17.9119V32.8427Z" fill="#111111" />
			<path d="M19.1541 32.8427H17.9102V34.0866H19.1541V32.8427Z" fill="#111111" />
			<path d="M21.6443 32.8427H20.4004V34.0866H21.6443V32.8427Z" fill="#111111" />
			<path d="M27.8631 32.8427H26.6191V34.0866H27.8631V32.8427Z" fill="#111111" />
			<path d="M30.3494 32.8427H29.1055V34.0866H30.3494V32.8427Z" fill="#111111" />
			<path d="M31.5955 32.8427H30.3516V34.0866H31.5955V32.8427Z" fill="#111111" />
			<path d="M32.8377 32.8427H31.5938V34.0866H32.8377V32.8427Z" fill="#111111" />
			<path d="M35.3279 32.8427H34.084V34.0866H35.3279V32.8427Z" fill="#111111" />
			<path d="M36.5701 32.8427H35.3262V34.0866H36.5701V32.8427Z" fill="#111111" />
			<path d="M39.0603 32.8427H37.8164V34.0866H39.0603V32.8427Z" fill="#111111" />
			<path d="M40.3025 32.8427H39.0586V34.0866H40.3025V32.8427Z" fill="#111111" />
			<path d="M45.2771 32.8427H44.0332V34.0866H45.2771V32.8427Z" fill="#111111" />
			<path d="M46.5232 32.8427H45.2793V34.0866H46.5232V32.8427Z" fill="#111111" />
			<path d="M6.71854 34.0872H5.47461V35.3312H6.71854V34.0872Z" fill="#111111" />
			<path d="M9.20683 34.0872H7.96289V35.3312H9.20683V34.0872Z" fill="#111111" />
			<path d="M10.4471 34.0872H9.20312V35.3312H10.4471V34.0872Z" fill="#111111" />
			<path d="M11.6912 34.0872H10.4473V35.3312H11.6912V34.0872Z" fill="#111111" />
			<path d="M16.6678 34.0872H15.4238V35.3312H16.6678V34.0872Z" fill="#111111" />
			<path d="M21.6443 34.0872H20.4004V35.3312H21.6443V34.0872Z" fill="#111111" />
			<path d="M25.3767 34.0872H24.1328V35.3312H25.3767V34.0872Z" fill="#111111" />
			<path d="M27.8631 34.0872H26.6191V35.3312H27.8631V34.0872Z" fill="#111111" />
			<path d="M30.3494 34.0872H29.1055V35.3312H30.3494V34.0872Z" fill="#111111" />
			<path d="M31.5955 34.0872H30.3516V35.3312H31.5955V34.0872Z" fill="#111111" />
			<path d="M34.0838 34.0872H32.8398V35.3312H34.0838V34.0872Z" fill="#111111" />
			<path d="M35.3279 34.0872H34.084V35.3312H35.3279V34.0872Z" fill="#111111" />
			<path d="M37.8162 34.0872H36.5723V35.3312H37.8162V34.0872Z" fill="#111111" />
			<path d="M40.3025 34.0872H39.0586V35.3312H40.3025V34.0872Z" fill="#111111" />
			<path d="M41.5467 34.0872H40.3027V35.3312H41.5467V34.0872Z" fill="#111111" />
			<path d="M44.0369 34.0872H42.793V35.3312H44.0369V34.0872Z" fill="#111111" />
			<path d="M45.2771 34.0872H44.0332V35.3312H45.2771V34.0872Z" fill="#111111" />
			<path d="M46.5232 34.0872H45.2793V35.3312H46.5232V34.0872Z" fill="#111111" />
			<path d="M6.71854 35.3335H5.47461V36.5774H6.71854V35.3335Z" fill="#111111" />
			<path d="M7.96659 35.3335H6.72266V36.5774H7.96659V35.3335Z" fill="#111111" />
			<path d="M9.20683 35.3335H7.96289V36.5774H9.20683V35.3335Z" fill="#111111" />
			<path d="M12.9353 35.3335H11.6914V36.5774H12.9353V35.3335Z" fill="#111111" />
			<path d="M14.1834 35.3335H12.9395V36.5774H14.1834V35.3335Z" fill="#111111" />
			<path d="M17.9119 35.3335H16.668V36.5774H17.9119V35.3335Z" fill="#111111" />
			<path d="M19.1541 35.3335H17.9102V36.5774H19.1541V35.3335Z" fill="#111111" />
			<path d="M22.8924 35.3335H21.6484V36.5774H22.8924V35.3335Z" fill="#111111" />
			<path d="M24.1326 35.3335H22.8887V36.5774H24.1326V35.3335Z" fill="#111111" />
			<path d="M26.6189 35.3335H25.375V36.5774H26.6189V35.3335Z" fill="#111111" />
			<path d="M31.5955 35.3335H30.3516V36.5774H31.5955V35.3335Z" fill="#111111" />
			<path d="M35.3279 35.3335H34.084V36.5774H35.3279V35.3335Z" fill="#111111" />
			<path d="M36.5701 35.3335H35.3262V36.5774H36.5701V35.3335Z" fill="#111111" />
			<path d="M37.8162 35.3335H36.5723V36.5774H37.8162V35.3335Z" fill="#111111" />
			<path d="M39.0603 35.3335H37.8164V36.5774H39.0603V35.3335Z" fill="#111111" />
			<path d="M40.3025 35.3335H39.0586V36.5774H40.3025V35.3335Z" fill="#111111" />
			<path d="M41.5467 35.3335H40.3027V36.5774H41.5467V35.3335Z" fill="#111111" />
			<path d="M42.7928 35.3335H41.5488V36.5774H42.7928V35.3335Z" fill="#111111" />
			<path d="M16.6678 36.5764H15.4238V37.8203H16.6678V36.5764Z" fill="#111111" />
			<path d="M17.9119 36.5764H16.668V37.8203H17.9119V36.5764Z" fill="#111111" />
			<path d="M20.4002 36.5764H19.1562V37.8203H20.4002V36.5764Z" fill="#111111" />
			<path d="M22.8924 36.5764H21.6484V37.8203H22.8924V36.5764Z" fill="#111111" />
			<path d="M25.3767 36.5764H24.1328V37.8203H25.3767V36.5764Z" fill="#111111" />
			<path d="M26.6189 36.5764H25.375V37.8203H26.6189V36.5764Z" fill="#111111" />
			<path d="M27.8631 36.5764H26.6191V37.8203H27.8631V36.5764Z" fill="#111111" />
			<path d="M31.5955 36.5764H30.3516V37.8203H31.5955V36.5764Z" fill="#111111" />
			<path d="M32.8377 36.5764H31.5938V37.8203H32.8377V36.5764Z" fill="#111111" />
			<path d="M35.3279 36.5764H34.084V37.8203H35.3279V36.5764Z" fill="#111111" />
			<path d="M36.5701 36.5764H35.3262V37.8203H36.5701V36.5764Z" fill="#111111" />
			<path d="M41.5467 36.5764H40.3027V37.8203H41.5467V36.5764Z" fill="#111111" />
			<path d="M44.0369 36.5764H42.793V37.8203H44.0369V36.5764Z" fill="#111111" />
			<path d="M45.2771 36.5764H44.0332V37.8203H45.2771V36.5764Z" fill="#111111" />
			<path d="M16.6678 37.8192H15.4238V39.0632H16.6678V37.8192Z" fill="#111111" />
			<path d="M17.9119 37.8192H16.668V39.0632H17.9119V37.8192Z" fill="#111111" />
			<path d="M19.1541 37.8192H17.9102V39.0632H19.1541V37.8192Z" fill="#111111" />
			<path d="M20.4002 37.8192H19.1562V39.0632H20.4002V37.8192Z" fill="#111111" />
			<path d="M21.6443 37.8192H20.4004V39.0632H21.6443V37.8192Z" fill="#111111" />
			<path d="M22.8924 37.8192H21.6484V39.0632H22.8924V37.8192Z" fill="#111111" />
			<path d="M25.3767 37.8192H24.1328V39.0632H25.3767V37.8192Z" fill="#111111" />
			<path d="M27.8631 37.8192H26.6191V39.0632H27.8631V37.8192Z" fill="#111111" />
			<path d="M30.3494 37.8192H29.1055V39.0632H30.3494V37.8192Z" fill="#111111" />
			<path d="M31.5955 37.8192H30.3516V39.0632H31.5955V37.8192Z" fill="#111111" />
			<path d="M35.3279 37.8192H34.084V39.0632H35.3279V37.8192Z" fill="#111111" />
			<path d="M36.5701 37.8192H35.3262V39.0632H36.5701V37.8192Z" fill="#111111" />
			<path d="M39.0603 37.8192H37.8164V39.0632H39.0603V37.8192Z" fill="#111111" />
			<path d="M41.5467 37.8192H40.3027V39.0632H41.5467V37.8192Z" fill="#111111" />
			<path d="M44.0369 37.8192H42.793V39.0632H44.0369V37.8192Z" fill="#111111" />
			<path d="M16.6678 39.0638H15.4238V40.3077H16.6678V39.0638Z" fill="#111111" />
			<path d="M17.9119 39.0638H16.668V40.3077H17.9119V39.0638Z" fill="#111111" />
			<path d="M19.1541 39.0638H17.9102V40.3077H19.1541V39.0638Z" fill="#111111" />
			<path d="M20.4002 39.0638H19.1562V40.3077H20.4002V39.0638Z" fill="#111111" />
			<path d="M21.6443 39.0638H20.4004V40.3077H21.6443V39.0638Z" fill="#111111" />
			<path d="M22.8924 39.0638H21.6484V40.3077H22.8924V39.0638Z" fill="#111111" />
			<path d="M25.3767 39.0638H24.1328V40.3077H25.3767V39.0638Z" fill="#111111" />
			<path d="M27.8631 39.0638H26.6191V40.3077H27.8631V39.0638Z" fill="#111111" />
			<path d="M29.1091 39.0638H27.8652V40.3077H29.1091V39.0638Z" fill="#111111" />
			<path d="M32.8377 39.0638H31.5938V40.3077H32.8377V39.0638Z" fill="#111111" />
			<path d="M34.0838 39.0638H32.8398V40.3077H34.0838V39.0638Z" fill="#111111" />
			<path d="M35.3279 39.0638H34.084V40.3077H35.3279V39.0638Z" fill="#111111" />
			<path d="M36.5701 39.0638H35.3262V40.3077H36.5701V39.0638Z" fill="#111111" />
			<path d="M41.5467 39.0638H40.3027V40.3077H41.5467V39.0638Z" fill="#111111" />
			<path d="M42.7928 39.0638H41.5488V40.3077H42.7928V39.0638Z" fill="#111111" />
			<path d="M44.0369 39.0638H42.793V40.3077H44.0369V39.0638Z" fill="#111111" />
			<path d="M16.6678 40.3064H15.4238V41.5504H16.6678V40.3064Z" fill="#111111" />
			<path d="M17.9119 40.3064H16.668V41.5504H17.9119V40.3064Z" fill="#111111" />
			<path d="M19.1541 40.3064H17.9102V41.5504H19.1541V40.3064Z" fill="#111111" />
			<path d="M20.4002 40.3064H19.1562V41.5504H20.4002V40.3064Z" fill="#111111" />
			<path d="M22.8924 40.3064H21.6484V41.5504H22.8924V40.3064Z" fill="#111111" />
			<path d="M26.6189 40.3064H25.375V41.5504H26.6189V40.3064Z" fill="#111111" />
			<path d="M27.8631 40.3064H26.6191V41.5504H27.8631V40.3064Z" fill="#111111" />
			<path d="M32.8377 40.3064H31.5938V41.5504H32.8377V40.3064Z" fill="#111111" />
			<path d="M34.0838 40.3064H32.8398V41.5504H34.0838V40.3064Z" fill="#111111" />
			<path d="M35.3279 40.3064H34.084V41.5504H35.3279V40.3064Z" fill="#111111" />
			<path d="M36.5701 40.3064H35.3262V41.5504H36.5701V40.3064Z" fill="#111111" />
			<path d="M37.8162 40.3064H36.5723V41.5504H37.8162V40.3064Z" fill="#111111" />
			<path d="M39.0603 40.3064H37.8164V41.5504H39.0603V40.3064Z" fill="#111111" />
			<path d="M40.3025 40.3064H39.0586V41.5504H40.3025V40.3064Z" fill="#111111" />
			<path d="M41.5467 40.3064H40.3027V41.5504H41.5467V40.3064Z" fill="#111111" />
			<path d="M45.2771 40.3064H44.0332V41.5504H45.2771V40.3064Z" fill="#111111" />
			<path d="M16.6678 41.5493H15.4238V42.7933H16.6678V41.5493Z" fill="#111111" />
			<path d="M26.6189 41.5493H25.375V42.7933H26.6189V41.5493Z" fill="#111111" />
			<path d="M27.8631 41.5493H26.6191V42.7933H27.8631V41.5493Z" fill="#111111" />
			<path d="M29.1091 41.5493H27.8652V42.7933H29.1091V41.5493Z" fill="#111111" />
			<path d="M32.8377 41.5493H31.5938V42.7933H32.8377V41.5493Z" fill="#111111" />
			<path d="M34.0838 41.5493H32.8398V42.7933H34.0838V41.5493Z" fill="#111111" />
			<path d="M35.3279 41.5493H34.084V42.7933H35.3279V41.5493Z" fill="#111111" />
			<path d="M36.5701 41.5493H35.3262V42.7933H36.5701V41.5493Z" fill="#111111" />
			<path d="M37.8162 41.5493H36.5723V42.7933H37.8162V41.5493Z" fill="#111111" />
			<path d="M40.3025 41.5493H39.0586V42.7933H40.3025V41.5493Z" fill="#111111" />
			<path d="M42.7928 41.5493H41.5488V42.7933H42.7928V41.5493Z" fill="#111111" />
			<path d="M46.5232 41.5493H45.2793V42.7933H46.5232V41.5493Z" fill="#111111" />
			<path d="M20.4002 42.7958H19.1562V44.0397H20.4002V42.7958Z" fill="#111111" />
			<path d="M21.6443 42.7958H20.4004V44.0397H21.6443V42.7958Z" fill="#111111" />
			<path d="M22.8924 42.7958H21.6484V44.0397H22.8924V42.7958Z" fill="#111111" />
			<path d="M25.3767 42.7958H24.1328V44.0397H25.3767V42.7958Z" fill="#111111" />
			<path d="M29.1091 42.7958H27.8652V44.0397H29.1091V42.7958Z" fill="#111111" />
			<path d="M30.3494 42.7958H29.1055V44.0397H30.3494V42.7958Z" fill="#111111" />
			<path d="M32.8377 42.7958H31.5938V44.0397H32.8377V42.7958Z" fill="#111111" />
			<path d="M35.3279 42.7958H34.084V44.0397H35.3279V42.7958Z" fill="#111111" />
			<path d="M36.5701 42.7958H35.3262V44.0397H36.5701V42.7958Z" fill="#111111" />
			<path d="M40.3025 42.7958H39.0586V44.0397H40.3025V42.7958Z" fill="#111111" />
			<path d="M41.5467 42.7958H40.3027V44.0397H41.5467V42.7958Z" fill="#111111" />
			<path d="M44.0369 42.7958H42.793V44.0397H44.0369V42.7958Z" fill="#111111" />
			<path d="M45.2771 42.7958H44.0332V44.0397H45.2771V42.7958Z" fill="#111111" />
			<path d="M46.5232 42.7958H45.2793V44.0397H46.5232V42.7958Z" fill="#111111" />
			<path d="M19.1541 44.0368H17.9102V45.2807H19.1541V44.0368Z" fill="#111111" />
			<path d="M20.4002 44.0368H19.1562V45.2807H20.4002V44.0368Z" fill="#111111" />
			<path d="M30.3494 44.0368H29.1055V45.2807H30.3494V44.0368Z" fill="#111111" />
			<path d="M31.5955 44.0368H30.3516V45.2807H31.5955V44.0368Z" fill="#111111" />
			<path d="M35.3279 44.0368H34.084V45.2807H35.3279V44.0368Z" fill="#111111" />
			<path d="M39.0603 44.0368H37.8164V45.2807H39.0603V44.0368Z" fill="#111111" />
			<path d="M40.3025 44.0368H39.0586V45.2807H40.3025V44.0368Z" fill="#111111" />
			<path d="M41.5467 44.0368H40.3027V45.2807H41.5467V44.0368Z" fill="#111111" />
			<path d="M42.7928 44.0368H41.5488V45.2807H42.7928V44.0368Z" fill="#111111" />
			<path d="M44.0369 44.0368H42.793V45.2807H44.0369V44.0368Z" fill="#111111" />
			<path d="M45.2771 44.0368H44.0332V45.2807H45.2771V44.0368Z" fill="#111111" />
			<path d="M46.5232 44.0368H45.2793V45.2807H46.5232V44.0368Z" fill="#111111" />
			<path d="M16.6678 45.283H15.4238V46.5269H16.6678V45.283Z" fill="#111111" />
			<path d="M17.9119 45.283H16.668V46.5269H17.9119V45.283Z" fill="#111111" />
			<path d="M19.1541 45.283H17.9102V46.5269H19.1541V45.283Z" fill="#111111" />
			<path d="M25.3767 45.283H24.1328V46.5269H25.3767V45.283Z" fill="#111111" />
			<path d="M26.6189 45.283H25.375V46.5269H26.6189V45.283Z" fill="#111111" />
			<path d="M27.8631 45.283H26.6191V46.5269H27.8631V45.283Z" fill="#111111" />
			<path d="M29.1091 45.283H27.8652V46.5269H29.1091V45.283Z" fill="#111111" />
			<path d="M30.3494 45.283H29.1055V46.5269H30.3494V45.283Z" fill="#111111" />
			<path d="M36.5701 45.283H35.3262V46.5269H36.5701V45.283Z" fill="#111111" />
			<path d="M40.3025 45.283H39.0586V46.5269H40.3025V45.283Z" fill="#111111" />
			<path d="M41.5467 45.283H40.3027V46.5269H41.5467V45.283Z" fill="#111111" />
			<path
				d="M12.8762 5.47749H5.47461V14.1845H14.1822V5.47749H12.8762ZM12.8762 12.879H6.78061V6.78349H12.8762V12.879Z"
				fill="#111111"
			/>
			<path
				d="M45.2179 5.47749H37.8164V14.1845H46.5239V5.47749H45.2179ZM45.2179 12.879H39.1224V6.78349H45.2179V12.879Z"
				fill="#111111"
			/>
			<path
				d="M12.8762 37.8192H5.47461V46.5268H14.1822V37.8192H12.8762ZM12.8762 45.2208H6.78061V39.1252H12.8762V45.2208Z"
				fill="#111111"
			/>
			<path d="M11.6947 7.96494H7.96289V11.6967H11.6947V7.96494Z" fill="#111111" />
			<path d="M44.0345 7.96494H40.3027V11.6967H44.0345V7.96494Z" fill="#111111" />
			<path d="M11.6947 40.3064H7.96289V44.0382H11.6947V40.3064Z" fill="#111111" />
		</symbol>

		{/* Shoe-Place */}
		<symbol id="shoe-place" viewBox="0 0 45 45" fill="none">
			<g clipPath="url(#clip0_963_8349)">
				<path
					d="M0 4.49912V8.99824H2.25181V4.49912C2.25181 3.90268 2.48835 3.33061 2.90968 2.90845C3.33102 2.48629 3.90268 2.24853 4.49912 2.24736H8.99824V0H4.49912C3.30624 0.00116209 2.16256 0.475569 1.31907 1.31907C0.475569 2.16256 0.00116209 3.30624 0 4.49912Z"
					fill="black"
				/>
				<path
					d="M2.25181 40.4964V35.9973H0V40.4964C0.00116209 41.6893 0.475569 42.833 1.31907 43.6765C2.16256 44.52 3.30624 44.9944 4.49912 44.9956H8.99824V42.7482H4.49912C3.90268 42.747 3.33102 42.5093 2.90968 42.0871C2.48835 41.6649 2.25181 41.0929 2.25181 40.4964Z"
					fill="black"
				/>
				<path
					d="M42.747 40.4964C42.747 41.0936 42.5097 41.6664 42.0874 42.0887C41.6652 42.5109 41.0924 42.7482 40.4952 42.7482H35.9961V44.9956H40.4952C41.6885 44.9944 42.8327 44.5202 43.6769 43.6768C44.5211 42.8334 44.9964 41.6897 44.9987 40.4964V35.9973H42.747V40.4964Z"
					fill="black"
				/>
				<path
					d="M40.4952 0H35.9961V2.26494H40.4952C41.0924 2.26494 41.6652 2.50219 42.0874 2.92447C42.5097 3.34676 42.747 3.91949 42.747 4.5167V9.01582H44.9987V4.5167C45.0005 3.92418 44.8852 3.33715 44.6597 2.78923C44.4341 2.24132 44.1027 1.74331 43.6844 1.32373C43.266 0.904143 42.769 0.571245 42.2217 0.3441C41.6745 0.116954 41.0877 -2.53288e-06 40.4952 0Z"
					fill="black"
				/>
				<path
					d="M19.4732 32.9844C19.9821 34.875 21.6786 36.25 23.7143 36.25C25.75 36.25 27.4464 34.875 27.9554 32.9844C28.125 32.4688 28.125 31.7812 27.9554 31.0938L27.1071 27.6562C26.7679 26.2812 26.7679 24.7344 27.2768 23.3594C27.7857 21.8125 28.125 19.75 28.125 17.6875C28.125 13.3906 26.5982 8.75 22.1875 8.75C17.4375 8.75 16.25 14.4219 16.25 17.5156C16.25 20.0938 16.5893 22.1563 17.0982 24.3906L19.4732 32.9844ZM22.1875 10.4688C26.2589 10.4688 26.4286 16.4844 26.4286 17.6875C26.4286 19.5781 26.0893 21.2969 25.75 22.6719C25.0714 24.3906 25.0714 26.2812 25.5804 28L26.4286 31.4375C26.4286 31.9531 26.4286 32.2969 26.4286 32.6406C26.0893 33.6719 24.9018 34.5312 23.7143 34.5312C22.5268 34.5312 21.3393 33.6719 21.1696 32.6406L18.7946 24.0469C18.1161 21.8125 17.9464 19.9219 17.9464 17.5156C17.9464 15.4531 18.625 10.4688 22.1875 10.4688Z"
					fill="black"
				/>
			</g>
			<defs>
				<clipPath id="clip0_963_8349">
					<rect width="45" height="45" fill="white" />
				</clipPath>
			</defs>
		</symbol>

		{/* Skate-Black */}
		<symbol id="skate-black" viewBox="0 0 26 26" fill="none">
			<rect width="26" height="26" fill="#111111" />
			<path
				d="M12.0452 21.3226C12.815 21.3226 13.439 20.692 13.439 19.9141C13.439 19.1362 12.815 18.5056 12.0452 18.5056C11.2754 18.5056 10.6514 19.1362 10.6514 19.9141C10.6514 20.692 11.2754 21.3226 12.0452 21.3226Z"
				stroke="white"
				strokeWidth="1.5"
				strokeLinejoin="round"
			/>
			<path
				d="M18.8606 11.0356L10.8342 19.137C9.69988 20.2833 6.20092 21.9541 5.07625 20.8175C4.59562 20.3318 4.68214 19.5159 5.25889 19.1467L6.17208 18.8068C7.44093 18.3308 8.59444 17.5828 9.54608 16.6114L16.5248 9.55914C17.486 8.58775 18.2262 7.4318 18.6972 6.14956L19.0336 5.22675C19.3989 4.64391 20.2064 4.55649 20.687 5.04218C21.331 5.69301 21.4079 6.98496 20.687 8.62661"
				stroke="white"
				strokeWidth="1.5"
				strokeLinejoin="round"
			/>
			<path
				d="M19.8411 13.4447C20.6109 13.4447 21.2349 12.8141 21.2349 12.0362C21.2349 11.2583 20.6109 10.6277 19.8411 10.6277C19.0713 10.6277 18.4473 11.2583 18.4473 12.0362C18.4473 12.8141 19.0713 13.4447 19.8411 13.4447Z"
				stroke="white"
				strokeWidth="1.5"
				strokeLinejoin="round"
			/>
		</symbol>

		{/* Skate-White */}
		<symbol id="skate-white" viewBox="0 0 26 26" fill="none">
			<rect width="26" height="26" fill="white" />
			<path
				d="M12.0452 21.3226C12.815 21.3226 13.439 20.692 13.439 19.9141C13.439 19.1362 12.815 18.5056 12.0452 18.5056C11.2754 18.5056 10.6514 19.1362 10.6514 19.9141C10.6514 20.692 11.2754 21.3226 12.0452 21.3226Z"
				stroke="black"
				strokeWidth="1.5"
				strokeLinejoin="round"
			/>
			<path
				d="M18.8606 11.0356L10.8342 19.137C9.69988 20.2833 6.20092 21.9541 5.07625 20.8175C4.59562 20.3318 4.68214 19.5159 5.25889 19.1467L6.17208 18.8068C7.44093 18.3308 8.59444 17.5828 9.54608 16.6114L16.5248 9.55914C17.486 8.58775 18.2262 7.4318 18.6972 6.14956L19.0336 5.22675C19.3989 4.64391 20.2064 4.55649 20.687 5.04218C21.331 5.69301 21.4079 6.98496 20.687 8.62661"
				stroke="black"
				strokeWidth="1.5"
				strokeLinejoin="round"
			/>
			<path
				d="M19.8411 13.4447C20.6109 13.4447 21.2349 12.8141 21.2349 12.0362C21.2349 11.2583 20.6109 10.6277 19.8411 10.6277C19.0713 10.6277 18.4473 11.2583 18.4473 12.0362C18.4473 12.8141 19.0713 13.4447 19.8411 13.4447Z"
				stroke="black"
				strokeWidth="1.5"
				strokeLinejoin="round"
			/>
		</symbol>

		{/* Shoe-Black */}
		<symbol id="shoe-black" viewBox="0 0 30 30" fill="none">
			<rect width="30" height="30" fill="black" />
			<path
				d="M26.5 8V20C26.5 21.24 25.49 22.25 24.25 22.25H6.25C5.01 22.25 4 21.24 4 20V18.07L12.76 13.01C12.93 12.91 13.09 12.79 13.23 12.65L17.13 8.75H21.26C22.5 8.75 23.51 9.76 23.51 11V12.5"
				stroke="white"
				strokeWidth="1.5"
				strokeMiterlimit="10"
			/>
			<path
				d="M12.64 17.81C11.68 17.1 12.41 15.69 12.67 15.27C12.2 15.79 11.73 16.3 11.37 16.86C10.8 17.74 10.55 18.71 10.94 19.33C11.64 20.45 13.31 19.93 14.37 19.48L24.25 15.31L14.49 17.89C13.67 18.1 13.01 18.08 12.64 17.81Z"
				fill="white"
			/>
		</symbol>

		{/* Shoe-White */}
		<symbol id="shoe-white" viewBox="0 0 30 30" fill="none">
			<rect width="30" height="30" fill="white" />
			<path
				d="M12.64 17.81C11.68 17.1 12.41 15.69 12.67 15.27C12.2 15.79 11.73 16.3 11.37 16.86C10.8 17.74 10.55 18.71 10.94 19.33C11.64 20.45 13.31 19.93 14.37 19.48L24.25 15.31L14.49 17.89C13.67 18.1 13.01 18.08 12.64 17.81Z"
				fill="#111111"
			/>
			<path
				d="M26.5 8V20C26.5 21.24 25.49 22.25 24.25 22.25H6.25C5.01 22.25 4 21.24 4 20V18.07L12.76 13.01C12.93 12.91 13.09 12.79 13.23 12.65L17.13 8.75H21.26C22.5 8.75 23.51 9.76 23.51 11V12.5"
				stroke="#111111"
				strokeWidth="1.5"
				strokeMiterlimit="10"
			/>
		</symbol>

		{/* Signout-Black */}
		<symbol id="signout-black" viewBox="0 0 26 26" fill="none">
			<rect width="26" height="26" fill="#111111" />
			<path
				d="M17.3047 7.71875L22.3831 12.7971L17.3047 17.8657"
				stroke="white"
				strokeWidth="1.5"
				strokeMiterlimit="10"
			/>
			<path
				d="M4.72363 10.5151V6.79639C4.72363 5.69182 5.61906 4.79639 6.72363 4.79639H12.9883C14.0929 4.79639 14.9883 5.69182 14.9883 6.79639V15.1636"
				stroke="white"
				strokeWidth="1.5"
			/>
			<path
				d="M14.9883 15.062L14.9883 19.2808C14.9883 20.3853 14.0929 21.2808 12.9883 21.2808L6.72364 21.2808C5.61907 21.2808 4.72364 20.3853 4.72364 19.2808L4.72364 14.7925C4.72364 13.6879 5.61907 12.7925 6.72364 12.7925L22.0977 12.7925"
				stroke="white"
				strokeWidth="1.5"
			/>
		</symbol>

		{/* Soccer-Black */}
		<symbol id="soccer-black" viewBox="0 0 26 26" fill="none">
			<rect width="26" height="26" fill="#111111" />
			<path
				d="M12.9644 9.40479L9.52441 11.9048L10.8344 15.9548H15.0944L16.4044 11.9048L12.9644 9.40479Z"
				stroke="white"
				strokeWidth="1.5"
				strokeMiterlimit="10"
			/>
			<path
				d="M3.36461 12.0149L4.85461 13.4049L6.65461 10.9749L6.63461 7.9549L4.52461 8.1549C3.69461 9.5849 3.22461 11.2549 3.22461 13.0249C3.22461 18.4049 7.59461 22.7749 12.9746 22.7749C18.3546 22.7749 22.7246 18.4049 22.7246 13.0249C22.7246 7.6449 18.3446 3.2749 12.9646 3.2749C10.5246 3.2749 8.28461 4.1749 6.57461 5.6649"
				stroke="white"
				strokeWidth="1.5"
				strokeMiterlimit="10"
			/>
			<path
				d="M9.03492 21.8449L10.8249 20.8549L9.06492 18.3949L6.18492 17.4849L5.79492 19.4849"
				stroke="white"
				strokeWidth="1.5"
				strokeMiterlimit="10"
			/>
			<path
				d="M20.1345 19.4849L19.7445 17.4849L16.8645 18.3949L15.1045 20.8549L16.8945 21.8449"
				stroke="white"
				strokeWidth="1.5"
				strokeMiterlimit="10"
			/>
			<path
				d="M21.3244 8.20483L19.2944 7.95483L19.2744 10.9748L21.0744 13.4048L22.5644 12.0148"
				stroke="white"
				strokeWidth="1.5"
				strokeMiterlimit="10"
			/>
			<path
				d="M10.9647 3.58496L10.0947 5.43496L12.9647 6.39496L15.8347 5.43496L14.9647 3.58496"
				stroke="white"
				strokeWidth="1.5"
				strokeMiterlimit="10"
			/>
		</symbol>

		{/* Soccer-White */}
		<symbol id="soccer-white" viewBox="0 0 26 26" fill="none">
			<rect width="26" height="26" fill="white" />
			<path
				d="M12.9644 9.40479L9.52441 11.9048L10.8344 15.9548H15.0944L16.4044 11.9048L12.9644 9.40479Z"
				stroke="black"
				strokeWidth="1.5"
				strokeMiterlimit="10"
			/>
			<path
				d="M3.36461 12.0149L4.85461 13.4049L6.65461 10.9749L6.63461 7.9549L4.52461 8.1549C3.69461 9.5849 3.22461 11.2549 3.22461 13.0249C3.22461 18.4049 7.59461 22.7749 12.9746 22.7749C18.3546 22.7749 22.7246 18.4049 22.7246 13.0249C22.7246 7.6449 18.3446 3.2749 12.9646 3.2749C10.5246 3.2749 8.28461 4.1749 6.57461 5.6649"
				stroke="black"
				strokeWidth="1.5"
				strokeMiterlimit="10"
			/>
			<path
				d="M9.03492 21.8449L10.8249 20.8549L9.06492 18.3949L6.18492 17.4849L5.79492 19.4849"
				stroke="black"
				strokeWidth="1.5"
				strokeMiterlimit="10"
			/>
			<path
				d="M20.1345 19.4849L19.7445 17.4849L16.8645 18.3949L15.1045 20.8549L16.8945 21.8449"
				stroke="black"
				strokeWidth="1.5"
				strokeMiterlimit="10"
			/>
			<path
				d="M21.3244 8.20483L19.2944 7.95483L19.2744 10.9748L21.0744 13.4048L22.5644 12.0148"
				stroke="black"
				strokeWidth="1.5"
				strokeMiterlimit="10"
			/>
			<path
				d="M10.9647 3.58496L10.0947 5.43496L12.9647 6.39496L15.8347 5.43496L14.9647 3.58496"
				stroke="black"
				strokeWidth="1.5"
				strokeMiterlimit="10"
			/>
		</symbol>

		{/* Star */}
		<symbol id="star" viewBox="0 0 23 22" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M11.77 0l2.645 8.141h8.56l-6.925 5.032 2.645 8.14-6.925-5.03-6.925 5.03 2.645-8.14L.565 8.14h8.56L11.77 0z"
				fill="currentColor"
			/>
		</symbol>

		{/* Swoosh */}
		<symbol id="swoosh" viewBox="0 0 26 26" fill="none">
			<rect width="26" height="26" fill="white" />
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M22.7505 9.44531L8.48949 15.4946C7.30216 15.9984 6.30332 16.2497 5.49841 16.2497C4.59274 16.2497 3.93299 15.9301 3.52782 15.2921C3.00241 14.4698 3.23207 13.1449 4.13341 11.7474C4.66857 10.9306 5.34891 10.1809 6.01191 9.46373C5.85591 9.71723 4.47899 12.0085 5.98482 13.0875C6.28274 13.3041 6.70632 13.4103 7.22741 13.4103C7.64557 13.4103 8.12549 13.3421 8.65307 13.2045L22.7505 9.44531Z"
				fill="#111111"
			/>
		</symbol>

		{/* Tennis-Black */}
		<symbol id="tennis-black" viewBox="0 0 26 26" fill="none">
			<rect width="26" height="26" fill="#111111" />
			<path
				d="M6.34473 5.86506C11.3347 4.62506 8.50473 9.38506 7.97473 13.4851C7.54473 16.8551 10.0647 19.2451 12.9747 19.2451"
				stroke="white"
				strokeWidth="1.5"
				strokeMiterlimit="10"
			/>
			<path
				d="M12.9746 19.2451C15.8846 19.2451 18.4046 16.8551 17.9746 13.4851C17.4546 9.38514 14.6146 4.62514 19.6046 5.86514C19.6046 5.86514 22.7246 8.42514 22.7246 13.0151C22.7246 18.3951 18.3546 22.7651 12.9746 22.7651C7.59461 22.7651 3.22461 18.3951 3.22461 13.0151C3.22461 7.63514 7.59461 3.26514 12.9746 3.26514C14.1846 3.26514 15.3446 3.48513 16.4146 3.89513"
				stroke="white"
				strokeWidth="1.5"
				strokeLinejoin="round"
			/>
		</symbol>

		{/* Tennis-White */}
		<symbol id="tennis-white" viewBox="0 0 26 26" fill="none">
			<rect width="26" height="26" fill="white" />
			<path
				d="M6.34473 5.86506C11.3347 4.62506 8.50473 9.38506 7.97473 13.4851C7.54473 16.8551 10.0647 19.2451 12.9747 19.2451"
				stroke="black"
				strokeWidth="1.5"
				strokeMiterlimit="10"
			/>
			<path
				d="M12.9746 19.2451C15.8846 19.2451 18.4046 16.8551 17.9746 13.4851C17.4546 9.38514 14.6146 4.62514 19.6046 5.86514C19.6046 5.86514 22.7246 8.42514 22.7246 13.0151C22.7246 18.3951 18.3546 22.7651 12.9746 22.7651C7.59461 22.7651 3.22461 18.3951 3.22461 13.0151C3.22461 7.63514 7.59461 3.26514 12.9746 3.26514C14.1846 3.26514 15.3446 3.48513 16.4146 3.89513"
				stroke="black"
				strokeWidth="1.5"
				strokeLinejoin="round"
			/>
		</symbol>
	</svg>
);

export default memo(Icons);
